export var headers = {
	"Project-Id-Version": "Open-Xchange 7",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2024-12-04 09:01+0100",
	"Last-Translator": "",
	Language: "de_DE",
	"Language-Team": "American English <kde-i18n-de@kde.org>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 3.5"
};
export default {
	headers: headers,
	"\u0000The document was not loaded successfully. Download is not possible.\u0001": [
	"Das Dokument konnte nicht erfolgreich geladen werden. Herunterladen ist nicht möglich."
],
	"\u0000The browser has blocked a pop-up window. Please enable pop-ups for download.\u0001": [
	"Ein Popup wurde vom Browser blockiert. Bitte aktivieren Sie Popups zum Herunterladen."
],
	"\u0000The server does not answer the request.\u0001": [
	"Der Server reagiert nicht auf die Anfrage."
],
	"\u0000Download Error\u0001": [
	"Fehler beim Herunterladen"
],
	"\u0000The document was not loaded successfully. Send as mail is not possible.\u0001": [
	"Das Dokument konnte nicht erfolgreich geladen werden. Das Versenden per E-Mail ist nicht möglich."
],
	"\u0000The server does not answer the request. Send as mail is not possible.\u0001": [
	"Der Server reagiert nicht auf die Anfrage. Das Versenden per E-Mail ist nicht möglich."
],
	"\u0000Empty document\u0001": [
	"Leeres Dokument"
],
	"\u0000Non convertible document content\u0001": [
	"Nicht konvertierbarer Dokumentinhalt"
],
	"\u0000This document is empty. Do you want to send this document as email content?\u0001": [
	"Dieses Dokument ist leer. Möchten Sie dieses Dokument als E-Mail-Inhalt versenden?"
],
	"\u0000This document contains elements that cannot be sent in an email. Do you want to send this document as email content?\u0001": [
	"Dieses Dokument enthält Elemente, die nicht per E-Mail verschickt werden können. Möchten Sie dieses Dokument als E-Mail-Inhalt versenden?"
],
	"\u0000Please use the most recent version of Google Chrome for full support.\u0001": [
	"Bitte verwenden Sie die neueste Version von Google Chrome für kompletten Support."
],
	"\u0000Please use the most recent version of Safari for full support.\u0001": [
	"Bitte verwenden Sie die neueste Version von Safari für kompletten Support."
],
	"\u0000Please use the most recent version of either Chrome, Firefox, Internet Explorer or Safari.\u0001": [
	"Bitte verwenden Sie die neueste Version von Chrome, Firefox, Internet Explorer oder Safari."
],
	"app\u0000Text\u0001": [
	"Text"
],
	"app\u0000Spreadsheet\u0001": [
	"Tabelle"
],
	"app\u0000Presentation\u0001": [
	"Präsentation"
],
	"\u0000Cannot synchronize while offline. Please reload the document as soon as you are online again.\u0001": [
	"Offline kann nicht synchronisiert werden. Bitte laden Sie das Dokument erneut, sobald Sie wieder online sind."
],
	"\u0000Cannot synchronize while offline. You have changes which could not be saved. Please try to copy the whole content into the clipboard and paste it into a new document as soon as you are online again\u0001": [
	"Offline kann nicht synchronisiert werden. Sie haben Änderungen, die nicht gespeichert werden konnten. Bitte kopieren Sie den kompletten Inhalt in die Zwischenablage und kopieren Sie ihn in ein neues Dokument, wenn Sie wieder online sind."
],
	"\u0000The document could not be loaded. The server connection was lost during loading the document. If the problem only persists with the same document it can be an error in the document.\u0001": [
	"Das Dokument konnte nicht geladen werden. Die Serververbindung wurde beim Laden des Dokuments unterbrochen. Wenn das Problem nur bei demselben Dokument auftritt, kann es sich um einen Fehler im Dokument handeln."
],
	"\u0000Due to a server connection error the editor switched to read-only mode. Please reload the document.\u0001": [
	"Aufgrund eines Fehlers bei der Serververbindung ist der Editor in den 'Nur-Lese-Modus' gewechselt. Bitte laden Sie das Dokument erneut."
],
	"\u0000Connection to the server hosting the document has been lost. Please reload the document.\u0001": [
	"Die Verbindung zum Server, auf dem das Dokument gespeichert ist, wurde unterbrochen. Bitte laden Sie das Dokument erneut."
],
	"\u0000Synchronization not possible, because an unknown error occured. Please reload the document for further usage.\u0001": [
	"Eine Synchronisierung ist nicht möglich, da ein unbekannter Fehler aufgetreten ist. Bitte laden Sie das Dokument zur weiteren Verwendung neu."
],
	"\u0000Synchronization not possible, because the server was not able to process the synchronization request. Please reload the document.\u0001": [
	"Eine Synchronisierung ist nicht möglich. Der Server kann die Synchronisationsanfrage nicht ausführen. Bitte laden Sie das Dokument erneut."
],
	"\u0000Synchronization not possible, because the server is not able to synchronize this document. Please reload the document for further usage.\u0001": [
	"Eine Synchronisierung ist nicht möglich. Der Server kann dieses Dokument nicht synchronisieren. Bitte laden Sie das Dokument für eine weitere Verwendung erneut."
],
	"\u0000You are not the editor of the document anymore. Synchronization is not possible, please reload the document.\u0001": [
	"Sie sind nicht mehr der Bearbeiter des Dokuments. Synchronisieren ist nicht möglich. Bitte laden Sie das Dokument erneut."
],
	"\u0000Connection to server was lost. Please reopen the document to acquire edit rights.\u0001": [
	"Die Verbindung zum Server wurde unterbrochen. Bitte öffnen Sie das Dokument erneut, um Bearbeitungsrechte zu erhalten."
],
	"\u0000An unrecoverable error occurred while modifying the document.\u0001": [
	"Beim Ändern des Dokuments ist ein nicht behebbarer Fehler aufgetreten."
],
	"\u0000An unrecoverable error occurred while loading the document.\u0001": [
	"Beim Laden des Dokuments ist ein nicht behebbarer Fehler aufgetreten."
],
	"\u0000Siri is not supported as input method. Please do not use to input text.\u0001": [
	"Siri wird als Eingabemethode nicht unterstützt. Bitte nicht zur Texteingabe verwenden."
],
	"\u0000The document could not be loaded. The server is currently too busy. Please try again later.\u0001": [
	"Das Dokument konnte nicht geladen werden. Der Server ist derzeit ausgelastet. Versuchen Sie es bitte später erneut."
],
	"\u0000A server component is not working. Please contact the server administrator.\u0001": [
	"Eine Serverkomponente funktioniert nicht. Bitte kontaktieren Sie den Serveradministrator."
],
	"\u0000The document is protected with a password.\u0001": [
	"Das Dokument ist passwortgeschützt."
],
	"\u0000Connection to the server has been lost. Please reload the document.\u0001": [
	"Die Verbindung zum Server wurde unterbrochen. Bitte laden Sie das Dokument erneut."
],
	"\u0000The server detected a synchronization problem with your client. Please reload the doument.\u0001": [
	"Der Server meldet ein Synchronisationsproblem mit Ihrem Client. Bitte laden Sie das Dokument erneut."
],
	"\u0000The document could not be loaded, because the server could not process our request successfully. Please try again later.\u0001": [
	"Das Dokument konnte nicht geladen werden, da der Server unsere Anfrage nicht erfolgreich verarbeiten konnte. Bitte versuchen Sie es später erneut."
],
	"\u0000The document could not be loaded, because the server is busy saving the requested document. Please try again later.\u0001": [
	"Das Dokument konnte nicht geladen werden, da der Server mit dem Speichern des angeforderten Dokuments beschäftigt ist. Bitte versuchen Sie es später erneut."
],
	"\u0000An unknown server error occurred while processing your request. Please retry again later.\u0001": [
	"Beim Verarbeiten Ihrer Anfrage ist ein unbekannter Serverfehler aufgetreten. Bitte versuchen Sie es später erneut."
],
	"\u0000The server we are connected to is going down. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Der verbundene Server ist ausgefallen. Um Ihre letzten Änderungen zu speichern, kopieren Sie den vollständigen Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The server we are connected to is going down. The document cannot be changed anymore. Please try to reload the document later.\u0001": [
	"Der verbundene Server ist ausgefallen. Das Dokument kann nicht mehr geändert werden. Versuchen Sie, das Dokument später erneut zu laden."
],
	"\u0000The server we are connected to is not available. The document cannot be changed anymore. Please try to reload the document later.\u0001": [
	"Der verbundene Server ist nicht verfügbar. Das Dokument kann nicht mehr geändert werden. Versuchen Sie, das Dokument später erneut zu laden."
],
	"\u0000The server we are connected to is not available. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Der verbundene Server ist nicht verfügbar. Um Ihre letzten Änderungen zu speichern, kopieren Sie den vollständigen Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000Your session is invalid and relogin failed. Please login again and to save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Ihre Sitzung ist ungültig und die erneute Anmeldung ist fehlgeschlagen. Bitte melden Sie sich erneut an und kopieren Sie zum Sichern Ihrer letzten Änderungen den kompletten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000Connection to server was lost. Switched to read-only mode.\u0001": [
	"Die Verbindung zum Server wurde unterbrochen. Es wurde in den 'Nur-Lese-Modus' umgeschaltet."
],
	"\u0000The server does not answer our action requests. Maybe the connection is unstable or the server side has problems.\u0001": [
	"Der Server antwortet nicht auf unsere Anfragen. Möglicherweise ist die Verbindung instabil oder es gibt serverseitige Probleme."
],
	"\u0000You do not have permissions to change this document.\u0001": [
	"Sie haben keine Berechtigung zum Ändern des Dokuments."
],
	"\u0000Connection to server was lost. Please wait, trying to synchronize to enable edit mode.\u0001": [
	"Die Verbindung zum Server wurde unterbrochen. Bitte warten Sie. Es wird versucht, zu synchronisieren, um den Bearbeitungsmodus zu aktivieren."
],
	"\u0000Connection to server was lost. Enable client to acquire edit rights.\u0001": [
	"Die Verbindung zum Server wurde unterbrochen. Starten Sie den Client, um Bearbeitungsrechte zu erhalten."
],
	"\u0000The document cannot be changed, because the format is not editable. To create an editable document, please use \"save as\" or copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument kann nicht geändert werden, da das Format nicht bearbeitet werden kann. Um ein editierbares Dokument zu erstellen, verwenden Sie bitte \"Speichern unter\" oder kopieren Sie den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000Your session is invalid. Please login again.\u0001": [
	"Ihre Sitzung ist ungültig. Bitte melden Sie sich erneut an."
],
	"\u0000The server detected a synchronization problem with your client. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Der Server hat ein Synchronisationsproblem mit dem Client erkannt. Um Ihre letzten Änderungen zu speichern, kopieren Sie den vollständigen Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000A previous session failure could be resolved but your latest changes could not be saved. Please copy the complete content to the clipboard and paste it into a new document.\u0001": [
	"Ein vorheriger Sitzungsfehler konnte behoben werden, aber Ihre letzten Änderungen konnten nicht gespeichert werden. Kopieren Sie den vollständigen Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The server detected a problem with your document. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Der Server hat ein Problem mit Ihrem Dokument erkannt. Um Ihre letzten Änderungen zu speichern, kopieren Sie den vollständigen Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000A conflict has occurred during simultaneous editing. To solve this conflict the document is now reloaded.\u0001": [
	"Bei der gleichzeitigen Bearbeitung ist ein Konflikt aufgetreten. Um diesen Konflikt zu lösen, wird das Dokument nun neu geladen."
],
	"\u0000The document was modified by an unsupported action. To solve this problem the document is now reloaded.\u0001": [
	"Das Dokument wurde durch eine nicht unterstützte Aktion geändert. Um dieses Problem zu lösen, wird das Dokument nun neu geladen."
],
	"\u0000The document has been moved to a different folder. To solve this problem the document is now reloaded for further usage.\u0001": [
	"Das Dokument wurde in einen anderen Ordner verschoben. Um dieses Problem zu lösen, wird das Dokument nun zur weiteren Verwendung neu geladen."
],
	"\u0000The document has been moved to a different folder. You have lost permissions to change this document. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument wurde in einen anderen Ordner verschoben. Sie haben die Berechtigung zum Ändern dieses Dokuments verloren. Um Ihre letzten Änderungen zu speichern, kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen ihn in ein neues Dokument ein."
],
	"\u0000The document has been deleted. To save your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument wurde gelöscht. Um Ihre letzten Änderungen zu speichern, kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen ihn in ein neues Dokument ein."
],
	"\u0000The document could not be saved. Your quota limit has been reached. Please free up storage space.\u0001": [
	"Das Dokument konnte nicht gespeichert werden. Ihr Kontingentlimit wurde erreicht. Bitte schaffen Sie freien Speicherplatz."
],
	"\u0000The document could not be written, because the document could not be found. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument konnte nicht geschrieben werden, da das Dokument nicht gefunden werden konnte. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document could not be read, because you lost read permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument konnte nicht gelesen werden, da Sie Ihre Leseberechtigungen verloren haben. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document could not be written, because you lost write permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument konnte nicht geschrieben werden, da Sie Ihre Schreibberechtigungen verloren haben. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document could not be saved. The server has not enough memory. To save your last changes, please copy the complete content into the clipboard and paste it into a new document. If you close the document, the last consistent version will be restored.\u0001": [
	"Das Dokument konnte nicht gespeichert werden. Der Server hat nicht ausreichend Speicher zur Verfügung. Zum Speichern Ihrer letzten Änderungen kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen ihn in ein neues Dokument ein. Wenn Sie das Dokument schließen, wird das letzte stabile Dokument wiederhergestellt."
],
	"\u0000The document could not be saved. The document is protected by a lock. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument konnte nicht gespeichert werden. Das Dokument hat einen Sperrschutz. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document is in an inconsistent state. To save your work, please copy the complete content into the clipboard and paste it into a new document. Furthermore the last consistent document was restored.\u0001": [
	"Das Dokument ist in einem instabilen Zustand. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen ihn in ein neues Dokument ein. Das letzte stabile Dokument wurde wiederhergestellt."
],
	"\u0000The document was saved successfully, but a backup copy could not be created. You do not have the permission to create a file in the folder.\u0001": [
	"Das Dokument wurde erfolgreich gespeichert. Es konnte jedoch keine Sicherungskopie erstellt werden. Sie haben keine Berechtigung zum Anlegen einer Datei in diesem Ordner."
],
	"\u0000The document was saved successfully, but a backup copy could not be created. You do not have the correct permissions in the folder.\u0001": [
	"Das Dokument wurde erfolgreich gespeichert. Es konnte jedoch keine Sicherungskopie erstellt werden. Sie haben nicht die entsprechenden Berechtigungen in dem Ordner."
],
	"\u0000The document was saved successfully, but a backup copy could not be created. Your quota limit has been reached. Please free up storage space. \u0001": [
	"Das Dokument wurde erfolgreich gespeichert. Es konnte jedoch keine Sicherungskopie erstellt werden. Ihr Speicherplatzlimit wurde erreicht. Bitte schaffen Sie freien Speicherplatz. "
],
	"\u0000The document was saved successfully, but a backup copy could not be created.\u0001": [
	"Das Dokument wurde erfolgreich gespeichert. Es konnte jedoch keine Sicherungskopie erstellt werden."
],
	"\u0000The document was saved successfully, but a backup copy could not be written due to a lock protection.\u0001": [
	"Das Dokument wurde erfolgreich gespeichert. Aufgrund eines Sperrschutzes konnte jedoch keine Sicherungskopie erstellt werden."
],
	"\u0000The document is inconsistent and the server was not able to create a backup file. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument ist inkonsistent. Der Server konnte keine Sicherungskopie erstellen. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document cannot be saved, because the server is too busy. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument kann nicht gespeichert werden, da der Server ausgelastet ist. Zum Speichern Ihrer Arbeit kopieren Sie bitte den Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document was only saved with some of your changes. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument wurde nur mit einigen Ihrer Änderungen gespeichert. Zum Sichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document cannot be saved because a new version has been uploaded. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument kann nicht gespeichert werden, da eine neue Version hochgeladen wurde. Um Ihre Arbeit zu speichern, kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen ihn in ein neues Dokument ein."
],
	"\u0000Could not create document because the necessary conversion of the file failed.\u0001": [
	"Das Dokument konnte nicht erstellt werden. Die nötige Konvertierung der Datei schlug fehl."
],
	"\u0000Could not create document because the necessary template file could not be read.\u0001": [
	"Das Dokument konnte nicht erstellt werden. Die benötigte Vorlagendatei konnte nicht gelesen werden."
],
	"\u0000Could not create document because the default template file could not be read.\u0001": [
	"Das Dokument konnte nicht erstellt werden. Die Standardvorlagendatei konnte nicht gelesen werden."
],
	"\u0000Could not create document due to missing folder permissions.\u0001": [
	"Das Dokument konnte aufgrund fehlender Ordnerberechtigungen nicht erstellt werden."
],
	"\u0000Could not create document because the allowed quota is reached. Please delete some items in order to create new ones.\u0001": [
	"Das Dokument konnte nicht erstellt werden. Das Speicherplatzlimit wurde erreicht. Löschen Sie bitte einige Objekte, um neue erstellen zu können."
],
	"\u0000Could not create document because the template file could not be found.\u0001": [
	"Das Dokument konnte nicht erstellt werden. Die Vorlagendatei konnte nicht gefunden werden."
],
	"\u0000Could not create document, because the template file is corrupt.\u0001": [
	"Das Dokument konnte nicht erstellt werden. Die Vorlagendatei ist beschädigt."
],
	"\u0000Saving the document to a new file failed, because the source document could not be found.\u0001": [
	"Das Speichern des Dokuments als neue Datei ist fehlgeschlagen, da das Ausgangsdokument nicht gefunden wurde."
],
	"\u0000Saving the document to a new file failed, because you lost read permissions on the source document. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Speichern des Dokuments ist nicht möglich, da Sie Ihre Leseberechtigungen für das Quelldokument verloren haben. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000Saving the document to a new file failed, because you have no write permissions.\u0001": [
	"Das Speichern des Dokuments als neue Datei ist fehlgeschlagen, da Sie keine Schreibberechtigungen haben."
],
	"\u0000The new document could not be saved, because your default folder is unknown.\u0001": [
	"Das neue Dokument konnte nicht gespeichert werden, da Ihr Standardordner nicht bekannt ist."
],
	"\u0000The new document could not be saved, because your quota has been reached.\u0001": [
	"Das neue Dokument konnte nicht gespeichert werden, da Ihr Kontingentlimit erreicht wurde."
],
	"\u0000The new document could not be saved, because you do not have permissions to create a file in the folder.\u0001": [
	"Das neue Dokument konnte nicht gespeichert werden. Sie haben keine Berechtigung zum Anlegen einer Datei in diesem Ordner."
],
	"\u0000The new document could not be saved, because an unknown error occurred.\u0001": [
	"Das neue Dokument konnte aufgrund eines unbekannten Fehlers nicht gespeichert werden."
],
	"\u0000The document cannot be found. Saving the document is not possible. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument konnte nicht gefunden werden. Das Speichern des Dokuments ist nicht möglich. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document could not be saved, because you lost read permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Speichern des Dokuments ist nicht möglich, da Sie Ihre Leseberechtigungen verloren haben. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document could not be saved, because you lost write permissions. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Speichern des Dokuments ist nicht möglich, da Sie Ihre Schreibberechtigungen verloren haben. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The server detected a synchronization problem with all clients of this document. Please reload the document.\u0001": [
	"Der Server meldet ein Synchronisationsproblem mit allen Clients dieses Dokuments. Bitte laden Sie das Dokument erneut."
],
	"\u0000Renaming the document failed.\u0001": [
	"Das Umbenennen des Dokuments ist fehlgeschlagen."
],
	"\u0000Renaming the document failed. The file name contains invalid characters\u0001": [
	"Das Umbenennen des Dokuments ist fehlgeschlagen. Der Dateiname enthält ungültige Zeichen."
],
	"\u0000Renaming the document failed. The storage containing the file does not support renaming a file.\u0001": [
	"Das Umbenennen des Dokuments ist fehlgeschlagen. Das Speichermedium, das die Datei enthält, unterstützt das Umbenennen von Dateien nicht."
],
	"\u0000Please wait. The document will be renamed and must be reloaded.\u0001": [
	"Bitte warten Sie. Das Dokument wird jetzt umbenannt und danach neu geladen."
],
	"\u0000An error occurred while loading the document.\u0001": [
	"Beim Laden des Dokuments ist ein Fehler aufgetreten."
],
	"\u0000The document could not be loaded, because the document data could not be read in time. Please try again later.\u0001": [
	"Das Dokument konnte nicht geladen werden. Die Dokumentdaten konnten nicht rechtzeitig gelesen werden. Bitte versuchen Sie es später erneut."
],
	"\u0000This document exceeds the size and complexity limits.\u0001": [
	"Dieses Dokument überschreitet das Größen- und Komplexitätslimit."
],
	"\u0000This document exceeds the text document size and complexity limits.\u0001": [
	"Dieses Dokument überschreitet die maximale Größe und Komplexität für Textdokumente."
],
	"\u0000This document exceeds the presentation size and complexity limits.\u0001": [
	"Dieses Dokument überschreitet das Limit der Präsentationsgröße und -komplexitiät."
],
	"\u0000This document exceeds the spreadsheet size and complexity limits.\u0001": [
	"Dieses Dokument überschreitet die maximale Größe und Komplexität für Tabellen."
],
	"\u0000This document exceeds the number of sheets limit.\u0001": [
	"Dieses Dokument überschreitet die maximal zulässige Anzahl von Tabellenblättern."
],
	"\u0000The engine used for calculating formulas is not available.\u0001": [
	"Die Engine zum Berechnen von Formeln ist nicht verfügbar."
],
	"\u0000This document could not be loaded, because it was created with a version of Microsoft Office prior to Office 2007.\u0001": [
	"Dieses Dokument konnte nicht geladen werden, da es mit einer Version von Microsoft Office vor Office 2007 erstellt wurde."
],
	"\u0000The document could not be loaded, because it contains an unsupported feature.\u0001": [
	"Das Dokument konnte nicht geladen werden, da es eine nicht unterstützte Funktion enthält."
],
	"\u0000The document could not be loaded, because it contains grouped text frames.\u0001": [
	"Das Dokument konnte nicht geladen werden, da es gruppierte Textrahmen enthält."
],
	"\u0000The document could not be loaded, because the document format is unknown\u0001": [
	"Das Dokument konnte nicht geladen werden, da das Dokumentenformat unbekannt ist."
],
	"\u0000The document could not be loaded into Presentation, because it's currently remotely presented. Please try again later.\u0001": [
	"Das Dokument konnte nicht in \"Präsentation\" geladen werden, da es derzeit einem Remote-Publikum präsentiert wird. Versuchen Sie es später erneut."
],
	"\u0000The document could not be loaded. The file format is not supported.\u0001": [
	"Das Dokument konnte nicht geladen werden. Das Dateiformat wird nicht unterstützt."
],
	"\u0000The document could not be read, because you do not have read permissions.\u0001": [
	"Das Dokument konnte nicht gelesen werden, da Sie keine Leseberechtigungen haben."
],
	"\u0000The document cannot be found. Please check, if the document has been removed.\u0001": [
	"Das Dokument konnte nicht gefunden werden. Bitte prüfen Sie, ob das Dokument entfernt wurde."
],
	"\u0000The document could not be loaded. The document is corrupt.\u0001": [
	"Das Dokument konnte nicht geladen werden. Das Dokument ist beschädigt."
],
	"\u0000The document could not be loaded. An unknown error occurred. Please try again later.\u0001": [
	"Das Dokument konnte nicht geladen werden. Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
],
	"\u0000The system is currently busy to store the document. Please try again later.\u0001": [
	"Das System ist derzeit mit dem Speichern des Dokuments beschäftigt. Bitte versuchen Sie es später erneut."
],
	"\u0000You do not have sufficient permissions to write the backup file.\u0001": [
	"Sie haben keine ausreichenden Berechtigungen zum Erstellen der Sicherungskopie."
],
	"\u0000An unknown error occurred.\u0001": [
	"Es ist ein unbekannter Fehler aufgetreten."
],
	"\u0000There is a configuration problem on the server. Please contact the server administrator.\u0001": [
	"Es gibt ein serverseitiges Konfigurationsproblem. Wenden Sie sich bitte an den Serveradministrator."
],
	"\u0000Your changes could not be written to the original document. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Ihre Änderungen konnten nicht in das Originaldokument geschrieben werden. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The connection to the document has been lost. Please reload the document.\u0001": [
	"Die Verbindung zum Dokument wurde unterbrochen. Bitte laden Sie das Dokument erneut."
],
	"\u0000The image type is not supported. The image cannot be embedded into the document.\u0001": [
	"Der Bildtyp wird nicht unterstützt. Das Bild kann nicht in das Dokument eingebettet werden."
],
	"\u0000A server component is not working correctly. Please contact the server administrator.\u0001": [
	"Eine Serverkomponente funktioniert nicht ordnungsgemäß. Bitte kontaktieren Sie den Serveradministrator."
],
	"\u0000The document could not be opened. The maximum number of simultaneously opened documents has been reached. Please close another document first and then open this document again.\u0001": [
	"Das Dokument konnte nicht geöffnet werden. Die maximale Anzahl gleichzeitig geöffneter Dokumente wurde erreicht. Bitte schließen Sie zunächst ein anderes Dokument, und öffnen Sie dann das Dokument erneut."
],
	"\u0000The document could not be loaded. Decrypting the document failed.\u0001": [
	"Das Dokument konnte nicht geladen werden. Das Entschlüsseln des Dokuments ist fehlgeschlagen."
],
	"\u0000The document could not be loaded. There is no document content available as the file size is zero.\u0001": [
	"Das Dokument konnte nicht geladen werden. Es ist kein Dokumentinhalt verfügbar, da die Dateigröße Null beträgt."
],
	"\u0000The document could not be loaded. The authentication for the Guard component failed. Please check your password.\u0001": [
	"Das Dokument konnte nicht geladen werden. Die Authentifizierung für die Guard-Komponente ist fehlgeschlagen. Bitte überprüfen Sie Ihr Passwort."
],
	"\u0000Error\u0001": [
	"Fehler"
],
	"\u0000The document exceeds the maximum permitted size of %1$s MB.\u0001": [
	"Das Dokument überschreitet die maximal zulässige Größe von %1$s MB."
],
	"\u0000The image cannot be embedded into the document because it exceeds the maximum permitted size of %1$s MB. The URL is used instead.\u0001": [
	"Das Bild kann nicht in das Dokument eingebettet werden, da es die maximal zulässige Größe von %1$s MB überschreitet. Stattdessen wird die URL verwendet."
],
	"\u0000The image cannot be embedded into the document because it exceeds the maximum permitted size. The URL is used instead.\u0001": [
	"Das Bild kann nicht in das Dokument eingebettet werden, da es die maximal zulässige Größe überschreitet. Stattdessen wird die URL verwendet."
],
	"\u0000The document has been locked by %1$s.\u0001": [
	"Das Dokument wurde von %1$s gesperrt."
],
	"\u0000The document has been locked by another user.\u0001": [
	"Das Dokument wurde durch einen anderen Benutzer gesperrt."
],
	"\u0000Your changes could not be written to the original document. A new document \"%1$s\" was stored in folder \"%2$s\" containing your latest changes.\u0001": [
	"Ihre Änderungen konnten nicht in das Originaldokument geschrieben werden. Ein neues Dokument \"%1$s\" mit Ihren letzten Änderungen wurde im Ordner \"%2$s\" gespeichert."
],
	"\u0000Your changes could not be written to the original document. A new document was stored containing your latest changes.\u0001": [
	"Ihre Änderungen konnten nicht in das Originaldokument geschrieben werden. Ein neues Dokument mit Ihren letzten Änderungen wurde gespeichert."
],
	"\u0000Your changes could not be written to the original document. A new document \"%1$s\" was stored in folder \"%2$s\" but some of your latest changes could not be saved. To save all of your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Ihre Änderungen konnten nicht in das Originaldokument geschrieben werden. Ein neues Dokument \"%1$s\" mit Ihren letzten Änderungen wurde im Ordner \"%2$s\" gespeichert, jedoch konnten einige Ihrer letzten Änderungen nicht gespeichert werden. Zum Speichern Ihrer gesamten letzten Änderungen kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000Your changes could not be written to the original document. A new document was stored but some of your latest changes could not be saved. To save all of your last changes, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Ihre Änderungen konnten nicht in das Originaldokument geschrieben werden. Ein neues Dokument mit Ihren letzten Änderungen wurde gespeichert, jedoch konnten einige Ihrer letzten Änderungen nicht gespeichert werden. Zum Speichern Ihrer gesamten letzten Änderungen kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen Sie ihn in ein neues Dokument ein."
],
	"\u0000The document cannot be loaded, because an older version of the document is currently in use by \"%1$s\". Please contact \"%1$s\" or try again later.\u0001": [
	"Das Dokument kann nicht geladen werden, da eine ältere Version des Dokuments derzeit von \"%1$s” in Gebrauch ist. Bitte kontaktieren Sie \"%1$s\" oder versuchen Sie es später noch einmal."
],
	"\u0000The document cannot be loaded, because an older version of the document is currently in use by someone. Please try again later.\u0001": [
	"Das Dokument kann nicht geladen werden, da eine ältere Version des Dokuments derzeit von jemandem in Gebrauch ist. Bitte versuchen Sie es später noch einmal."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because \"%1$s\" lost write permission. Please contact \"%1$s\" to continue the collaboration or close the document and try to open it later.\u0001": [
	"Die Berechtigungen für das Dokument haben sich geändert. Das Dokument konnte nicht gespeichert werden, weil \"%1$s\" keine Schreibberechtigung mehr hat. Bitte kontaktieren Sie \"%1$s\", um mit der Zusammenarbeit fortzufahren oder schließen Sie das Dokument und versuchen Sie, es später erneut zu öffnen."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because the editor lost write permission. Please contact the editor to continue the collaboration or close the document and try to open it later.\u0001": [
	"Die Berechtigungen für das Dokument haben sich geändert. Das Dokument konnte nicht gespeichert werden, weil der Bearbeiter keine Schreibberechtigung mehr hat. Bitte kontaktieren Sie den Bearbeiter, um mit der Zusammenarbeit fortzufahren oder schließen Sie das Dokument und versuchen Sie, es später erneut zu öffnen."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because \"%1$s\" lost read permission. Please contact \"%1$s\" to continue the collaboration or close the document and try to open it later.\u0001": [
	"Die Berechtigungen für das Dokument haben sich geändert. Das Dokument konnte nicht gespeichert werden, weil \"%1$s\" keine Leseberechtigung mehr hat. Bitte kontaktieren Sie \"%1$s\", um mit der Zusammenarbeit fortzufahren oder schließen Sie das Dokument und versuchen Sie, es später erneut zu öffnen."
],
	"\u0000The permissions of the document have changed. The document could not be saved, because the editor lost read permission. Please contact the editor to continue the collaboration or close the document and try to open it later.\u0001": [
	"Die Berechtigungen für das Dokument haben sich geändert. Das Dokument konnte nicht gespeichert werden, weil der Bearbeiter keine Leseberechtigung mehr hat. Bitte kontaktieren Sie den Bearbeiter, um mit der Zusammenarbeit fortzufahren oder schließen Sie das Dokument und versuchen Sie, es später erneut zu öffnen."
],
	"\u0000The document is in an inconsistent state. To save your work, please copy the complete content into the clipboard and paste it into a new document.\u0001": [
	"Das Dokument ist in einem instabilen Zustand. Zum Speichern Ihrer Arbeit kopieren Sie bitte den gesamten Inhalt in die Zwischenablage und fügen ihn in ein neues Dokument ein."
],
	"\u0000Could not create document, because of an unknown error.\u0001": [
	"Das Dokument konnte aufgrund eines unbekannten Fehlers nicht erstellt werden."
],
	"\u0000The new document could not be saved, because of an unknown error.\u0001": [
	"Das neue Dokument konnte aufgrund eines unbekannten Fehlers nicht gespeichert werden."
],
	"\u0000An unknown synchronization error occurred.\u0001": [
	"Es ist ein unbekannter Synchronisationsfehler aufgetreten."
],
	"\u0000An unknown error ocurred.\u0001": [
	"Es ist ein unbekannter Fehler aufgetreten."
],
	"\u0000Synchronization Error\u0001": [
	"Synchronisationsfehler"
],
	"\u0000Synchronization\u0001": [
	"Synchronisation"
],
	"\u0000Connection Error\u0001": [
	"Verbindungsfehler"
],
	"\u0000Connection Warning\u0001": [
	"Warnhinweis zur Verbindung"
],
	"\u0000Warning\u0001": [
	"Warnhinweis"
],
	"\u0000Rename Error\u0001": [
	"Fehler beim Umbenennen"
],
	"\u0000Rename Warning\u0001": [
	"Warnhinweis zum Umbenennen"
],
	"\u0000Read-Only Mode\u0001": [
	"Nur-Lese-Modus"
],
	"\u0000Restore Document Error\u0001": [
	"Fehler bei der Wiederherstellung des Dokuments"
],
	"\u0000Synchronization between client and server was successful. You can edit the document again.\u0001": [
	"Die Synchronisation zwischen Client und Server war erfolgreich. Sie können das Dokument wieder bearbeiten."
],
	"\u0000Synchronization between client and server was successful. You see the latest document content.\u0001": [
	"Die Synchronisation zwischen Client und Server war erfolgreich. Sie sehen den aktuellen Inhalt des Dokuments."
],
	"\u0000Edit rights are being transferred to you. Please wait a moment.\u0001": [
	"Bearbeitungsrechte werden an Sie übertragen. Bitte warten Sie einen Moment."
],
	"\u0000Edit rights cannot be transferred. The server is busy to save the document. Please try again later.\u0001": [
	"Bearbeitungrechte können nicht übertragen werden. Der Server ist mit dem Speichern des Dokuments ausgelastet. Bitte versuchen Sie es später erneut."
],
	"\u0000Edit rights are still being transferred to you. The system is busy and will need more time. Please be patient.\u0001": [
	"Die Übertragung der Bearbeitungsrechte dauert an. Das System ist ausgelastet und benötigt noch etwas Zeit. Bitte haben Sie Geduld."
],
	"\u0000Someone else already wants to receive the edit rights for this document. Please try again later.\u0001": [
	"Ein anderer Benutzer hat bereits Bearbeitungsrechte für das Dokument angefordert. Bitte versuchen Sie es erneut."
],
	"\u0000You have edit rights.\u0001": [
	"Sie haben Bearbeitungsrechte."
],
	"\u0000Please wait until document is loaded completely.\u0001": [
	"Bitte warten Sie, bis das Dokument vollständig geladen wurde."
],
	"\u0000Saving your document failed, we can try to restore your document using backup data.\u0001": [
	"Das Speichern Ihres Dokuments ist fehlgeschlagen. Wir können versuchen, Ihr Dokument anhand von Backup-Daten wiederherzustellen."
],
	"\u0000The synchronization process between client and server was not successful.\u0001": [
	"Der Synchronisationsprozess zwischen Client und Server war nicht erfolgreich."
],
	"\u0000Image\u0001": [
	"Bild"
],
	"\u0000The image could not be embedded into the document. The external URL is used instead.\u0001": [
	"Das Bild konnte nicht in das Dokument eingebettet werden. Stattdessen wird die externe URL verwendet."
],
	"\u0000Transferring edit rights to %1$s. Your latest changes will be saved now.\u0001": [
	"Bearbeitungsrechte werden an %1$s übertragen. Ihre letzten Änderungen werden nun gespeichert."
],
	"\u0000Transferring edit rights to another user. Your latest changes will be saved now.\u0001": [
	"Bearbeitungsrechte werden an einen anderen Benutzer übertragen. Ihre letzten Änderungen werden nun gespeichert."
],
	"\u0000%1$s is currently editing this document.\u0001": [
	"Das Dokument wird derzeit von %1$s bearbeitet."
],
	"\u0000Another user is currently editing this document.\u0001": [
	"Das Dokument wird derzeit von einem anderen Benutzer bearbeitet."
],
	"\u0000Document was converted and stored in your documents folder as \"%1$s\".\u0001": [
	"Das Dokument wurde konvertiert und in Ihrem Dokumentenordner als \"%1$s\" gespeichert."
],
	"\u0000Document was converted and stored as \"%1$s\".\u0001": [
	"Das Dokument wurde konvertiert und unter \"%1$s\" gespeichert."
],
	"\u0000Document \"%1$s\" was created in your documents folder to allow editing.\u0001": [
	"Das Dokument \"%1$s\" wurde in Ihrem Dokumentenordner erstellt, um eine Bearbeitung zu ermöglichen."
],
	"\u0000Document has been stored in your documents folder as \"%1$s\".\u0001": [
	"Das Dokument wurde in Ihrem Dokumentenordner unter \"%1$s\" gespeichert."
],
	"\u0000The document was saved as a template \"%1$s\" in folder \"%2$s\".\u0001": [
	"Das Dokument wurde als Vorlage \"%1$s\" im Ordner \"%2$s\" gespeichert."
],
	"\u0000Document \"%1$s\" was created in folder \"%2$s\".\u0001": [
	"Das Dokument \"%1$s\" wurde im Ordner \"%2$s\" angelegt."
],
	"\u0000Your document could be restored as \"%1$s\" successfully.\u0001": [
	"Ihr Dokument konnte erfolgreich unter \"%1$s\" wiederhergestellt werden."
],
	"\u0000Restore Document\u0001": [
	"Dokument wiederherstellen"
],
	"\u0000unnamed\u0001": [
	"Unbenannt"
],
	"document-name\u0000Text document\u0001": [
	"Textdokument"
],
	"document-name\u0000Text document (encrypted)\u0001": [
	"Textdokument (verschlüsselt)"
],
	"document-name\u0000New text document\u0001": [
	"Neues Textdokument"
],
	"document-name\u0000New text document (encrypted)\u0001": [
	"Neues Textdokument (verschlüsselt)"
],
	"document-name\u0000Spreadsheet\u0001": [
	"Tabelle"
],
	"document-name\u0000Spreadsheet (encrypted)\u0001": [
	"Tabellendokument (verschlüsselt)"
],
	"document-name\u0000New spreadsheet\u0001": [
	"Neues Tabellendokument"
],
	"document-name\u0000New spreadsheet (encrypted)\u0001": [
	"Neues Tabellendokument (verschlüsselt)"
],
	"document-name\u0000Presentation\u0001": [
	"Präsentation"
],
	"document-name\u0000Presentation (encrypted)\u0001": [
	"Präsentation (verschlüsselt)"
],
	"document-name\u0000New presentation\u0001": [
	"Neue Präsentation"
],
	"document-name\u0000New presentation (encrypted)\u0001": [
	"Neue Präsentation (verschlüsselt)"
],
	"menu-title\u0000View\u0001": [
	"Ansicht"
],
	"menu-title\u0000More\u0001": [
	"Weitere"
],
	"menu-title\u0000Options\u0001": [
	"Optionen"
],
	"menu-title\u0000Zoom\u0001": [
	"Zoom"
],
	"\u0000Download\u0001": [
	"Herunterladen"
],
	"\u0000Print as PDF\u0001": [
	"Als PDF drucken"
],
	"\u0000Send as mail\u0001": [
	"Als E-Mail versenden"
],
	"\u0000Attach document to mail\u0001": [
	"Dokument an E-Mail anhängen"
],
	"\u0000Attach as PDF to mail\u0001": [
	"Als PDF an E-Mail anhängen"
],
	"\u0000Send content as mail\u0001": [
	"Inhalt als E-Mail senden"
],
	"\u0000Edit document\u0001": [
	"Dokument bearbeiten"
],
	"\u0000Edit\u0001": [
	"Bearbeiten"
],
	"\u0000Reload document\u0001": [
	"Dokument neu laden"
],
	"\u0000Reload\u0001": [
	"Neu laden"
],
	"\u0000Load restored document\u0001": [
	"Wiederhergestelltes Dokument laden"
],
	"\u0000Load\u0001": [
	"Laden"
],
	"\u0000Fit to screen width\u0001": [
	"An Bildschirmbreite anpassen"
],
	"\u0000Fit to screen size\u0001": [
	"An Bildschirmgröße anpassen"
],
	"\u0000Open document\u0001": [
	"Dokument öffnen"
],
	"\u0000Add template\u0001": [
	"Vorlage hinzufügen"
],
	"\u0000Close document\u0001": [
	"Dokument schließen"
],
	"\u0000Zoom out\u0001": [
	"Verkleinern"
],
	"\u0000Zoom in\u0001": [
	"Vergrößern"
],
	"\u0000%1$d%\u0001": [
	"%1$d%"
],
	"\u0000Image could not be loaded.\u0001": [
	"Das Bild konnte nicht geladen werden."
],
	"chart-format\u0000Grayscale\u0001": [
	"Graustufen"
],
	"chart-format\u0000Accents\u0001": [
	"Akzente"
],
	"chart-format\u0000Color set\u0001": [
	"Farbset"
],
	"chart-format\u0000Predefined color set\u0001": [
	"Vordefiniertes Farbset"
],
	"chart-format\u0000Color\u0001": [
	"Farbe"
],
	"chart-legend\u0000Legend position\u0001": [
	"Legendenposition"
],
	"chart-legend\u0000Visibility and position of the chart legend\u0001": [
	"Sichtbarkeit und Platzierung der Diagrammlegende"
],
	"chart-legend\u0000Legend\u0001": [
	"Legende"
],
	"chart-legend\u0000Off\u0001": [
	"Aus"
],
	"chart-legend\u0000Top\u0001": [
	"Oben"
],
	"chart-legend\u0000Bottom\u0001": [
	"Unten"
],
	"chart-legend\u0000Left\u0001": [
	"Links"
],
	"chart-legend\u0000Right\u0001": [
	"Rechts"
],
	"chart-format\u0000Style set\u0001": [
	"Formatvorlage"
],
	"chart-format\u0000Predefined style set\u0001": [
	"Vordefiniertes Formatvorlage"
],
	"chart-format\u0000Style\u0001": [
	"Vorlage"
],
	"chart-format\u0000Light\u0001": [
	"Hell"
],
	"chart-format\u0000Colored\u0001": [
	"Farbig"
],
	"chart-format\u0000Dark\u0001": [
	"Dunkel"
],
	"\u0000Chart type\u0001": [
	"Diagrammtyp"
],
	"drawing-pos\u0000Align\u0001": [
	"Ausrichten"
],
	"drawing-pos\u0000Align left\u0001": [
	"Links ausrichten"
],
	"drawing-pos\u0000Align center\u0001": [
	"Zentriert ausrichten"
],
	"drawing-pos\u0000Align right\u0001": [
	"Rechts ausrichten"
],
	"drawing-pos\u0000Align top\u0001": [
	"Oben ausrichten"
],
	"drawing-pos\u0000Align middle\u0001": [
	"Mittig ausrichten"
],
	"drawing-pos\u0000Align bottom\u0001": [
	"Unten ausrichten"
],
	"drawing-pos\u0000Distribute horizontally on slide\u0001": [
	"Horizontal auf Folie verteilen"
],
	"\u0000Distribute selected objects horizontally on slide\u0001": [
	"Ausgewählte Objekte horizontal auf Folie verteilen"
],
	"drawing-pos\u0000Distribute vertically on slide\u0001": [
	"Vertikal auf Folie verteilen"
],
	"\u0000Distribute selected objects vertically on slide\u0001": [
	"Ausgewählte Objekte vertikal auf Folie verteilen"
],
	"drawing-pos\u0000Distribute horizontally among objects\u0001": [
	"Horizontal zwischen den Objekten verteilen"
],
	"\u0000Distribute selected objects horizontally among themselves\u0001": [
	"Ausgewählte Objekte horizontal verteilen"
],
	"drawing-pos\u0000Distribute vertically among objects\u0001": [
	"Vertikal zwischen Objekten verteilen"
],
	"\u0000Distribute selected objects vertically among themselves\u0001": [
	"Ausgewählte Objekte vertikal verteilen"
],
	"drawing-pos\u0000Arrange\u0001": [
	"Anordnen"
],
	"drawing-pos\u0000Reorder\u0001": [
	"Anordnen"
],
	"drawing-pos\u0000Rotate\u0001": [
	"Drehen"
],
	"drawing-pos\u0000Bring to front\u0001": [
	"In den Vordergrund"
],
	"drawing-pos\u0000Bring object to the front\u0001": [
	"Objekt in den Vordergrund"
],
	"drawing-pos\u0000Bring forward\u0001": [
	"Ebene nach vorne"
],
	"drawing-pos\u0000Move object up one placement to the front\u0001": [
	"Objekt um eine Ebene nach vorne verschieben"
],
	"drawing-pos\u0000Send backward\u0001": [
	"Ebene nach hinten"
],
	"drawing-pos\u0000Send object one placement to the back\u0001": [
	"Objekt um eine Ebene nach hinten verschieben"
],
	"drawing-pos\u0000Send to back\u0001": [
	"In den Hintergrund"
],
	"drawing-pos\u0000Send object to the back\u0001": [
	"Objekt in den Hintergrund"
],
	"drawing-pos\u0000Rotate right 90°\u0001": [
	"Um 90° nach rechts drehen"
],
	"drawing-pos\u0000Rotate right 90 degrees\u0001": [
	"Um 90 Grad nach rechts drehen"
],
	"drawing-pos\u0000Rotate left 90°\u0001": [
	"Um 90 ° nach links drehen"
],
	"drawing-pos\u0000Rotate left 90 degrees\u0001": [
	"Um 90 Grad nach links drehen"
],
	"drawing-pos\u0000Flip vertical\u0001": [
	"Vertikal spiegeln"
],
	"drawing-pos\u0000Flip object vertical\u0001": [
	"Objekt vertikal spiegeln"
],
	"drawing-pos\u0000Flip horizontal\u0001": [
	"Horizontal spiegeln"
],
	"drawing-pos\u0000Flip object horizontal\u0001": [
	"Objekt horizontal spiegeln"
],
	"arrows\u0000Arrow style\u0001": [
	"Pfeilstil"
],
	"arrows\u0000Change line endings\u0001": [
	"Zeilenenden ändern"
],
	"borders\u0000No line\u0001": [
	"Kein Rahmen"
],
	"borders\u0000Hair line\u0001": [
	"Haarlinie"
],
	"borders\u0000Thin line\u0001": [
	"Dünne Linie"
],
	"borders\u0000Dashed thin line\u0001": [
	"Gestrichelte dünne Linie"
],
	"borders\u0000Dotted thin line\u0001": [
	"Gepunktete dünne Linie"
],
	"borders\u0000Dot-and-dash thin line\u0001": [
	"Dünne Strichpunktlinie"
],
	"borders\u0000Two-dots-and-dash thin line\u0001": [
	"Dünne Strichzweipunktlinie"
],
	"borders\u0000Medium line\u0001": [
	"Halbfette Linie"
],
	"borders\u0000Dashed medium line\u0001": [
	"Gestrichelte halbfette Linie"
],
	"borders\u0000Dotted medium line\u0001": [
	"Gepunktete halbfette Linie"
],
	"borders\u0000Dot-and-dash medium line\u0001": [
	"Halbfette Strichpunktlinie"
],
	"borders\u0000Two-dots-and-dash medium line\u0001": [
	"Halbfette Strichzweipunktlinie"
],
	"borders\u0000Thick line\u0001": [
	"Fette Linie"
],
	"drawing\u0000Line style\u0001": [
	"Linienstil"
],
	"drawing\u0000Border style\u0001": [
	"Rahmenstil"
],
	"\u0000Insert a shape\u0001": [
	"Form einfügen"
],
	"\u0000Shape\u0001": [
	"Form"
],
	"\u0000Insert image\u0001": [
	"Bild einfügen"
],
	"\u0000Upload local image\u0001": [
	"Lokales Bild hochladen"
],
	"\u0000Insert image URL\u0001": [
	"Bild-URL einfügen"
],
	"\u0000Enter image URL\u0001": [
	"Bild-URL eingeben"
],
	"drawing\u0000Line color\u0001": [
	"Linienfarbe"
],
	"drawing\u0000Border color\u0001": [
	"Rahmenfarbe"
],
	"drawing\u0000Background color\u0001": [
	"Hintergrundfarbe"
],
	"drawing\u0000Insert a text frame\u0001": [
	"Textrahmen einfügen"
],
	"\u0000Local file\u0001": [
	"Lokale Datei"
],
	"\u0000From Drive\u0001": [
	"Von Drive"
],
	"\u0000From URL\u0001": [
	"Von URL"
],
	"\u0000Crop\u0001": [
	"Zuschneiden"
],
	"\u0000Crop image\u0001": [
	"Bild zuschneiden"
],
	"\u0000Fill\u0001": [
	"Ausfüllen"
],
	"\u0000Scale the image to fill the frame. The image aspect ratio is maintained. The image might be cropped\u0001": [
	"Das Bild so skalieren, dass es den Rahmen ausfüllt. Das Seitenverhältnis bleibt erhalten. Bildränder werden eventuell beschnitten."
],
	"\u0000Fit\u0001": [
	"Einpassen"
],
	"\u0000Scale the image to fit the frame. The image aspect ratio is maintained. There might be empty space inside the frame.\u0001": [
	"Das Bild so skalieren, dass es in den Rahmen passt. Das Seitenverhältnis bleibt erhalten. Teile das Rahmens bleiben eventuell leer."
],
	"\u0000Position ...\u0001": [
	"Position ..."
],
	"\u0000Open the crop position dialog\u0001": [
	"Dialog für Zuschnittposition öffnen"
],
	"drawing\u0000Chart\u0001": [
	"Diagramm"
],
	"drawing\u0000Image\u0001": [
	"Bild"
],
	"drawing\u0000Shape\u0001": [
	"Form"
],
	"drawing\u0000Line\u0001": [
	"Linie"
],
	"drawing\u0000Text frame\u0001": [
	"Textrahmen"
],
	"drawing\u0000Diagram\u0001": [
	"Flussdiagramm"
],
	"drawing\u0000Drawing\u0001": [
	"Zeichnung"
],
	"shape\u0000Lines\u0001": [
	"Linien"
],
	"shape\u0000Line\u0001": [
	"Linie"
],
	"shape\u0000Line arrow\u0001": [
	"Pfeil"
],
	"shape\u0000Line arrow: double\u0001": [
	"Doppelpfeil"
],
	"shape\u0000Connector: elbow\u0001": [
	"Verbindung: gewinkelt"
],
	"shape\u0000Connector: elbow arrow\u0001": [
	"Gewinkelte Verbindung mit Pfeil"
],
	"shape\u0000Connector: elbow double-arrow\u0001": [
	"Gewinkelte Verbindung mit Doppelpfeil"
],
	"shape\u0000Connector: curved\u0001": [
	"Verbindung: gebogen"
],
	"shape\u0000Connector: curved arrow\u0001": [
	"Gekrümmte Verbindung mit Pfeil"
],
	"shape\u0000Connector: curved double-arrow\u0001": [
	"Gekrümmte Verbindung mit Doppelpfeil"
],
	"shape\u0000Basic shapes\u0001": [
	"Standardformen"
],
	"shape\u0000Ellipse\u0001": [
	"Ellipse"
],
	"shape\u0000Isosceles triangle\u0001": [
	"Gleichschenkliges Dreieck"
],
	"shape\u0000Right triangle\u0001": [
	"Rechtwinkliges Dreieck"
],
	"shape\u0000Parallelogram\u0001": [
	"Parallelogramm"
],
	"shape\u0000Trapezoid\u0001": [
	"Trapezoid"
],
	"shape\u0000Diamond\u0001": [
	"Raute"
],
	"shape\u0000Pentagon\u0001": [
	"Fünfeck"
],
	"shape\u0000Hexagon\u0001": [
	"Sechseck"
],
	"shape\u0000Heptagon\u0001": [
	"Siebeneck"
],
	"shape\u0000Octagon\u0001": [
	"Achteck"
],
	"shape\u0000Decagon\u0001": [
	"Zehneck"
],
	"shape\u0000Dodecagon\u0001": [
	"Zwölfeck"
],
	"shape\u0000Circle pie\u0001": [
	"Kreis"
],
	"shape\u0000Circle segment\u0001": [
	"Akkord"
],
	"shape\u0000Teardrop\u0001": [
	"Träne"
],
	"shape\u0000Frame\u0001": [
	"Rahmen"
],
	"shape\u0000Half frame\u0001": [
	"Halber Rahmen"
],
	"shape\u0000Corner\u0001": [
	"L-Form"
],
	"shape\u0000Diagonal stripe\u0001": [
	"Diagonaler Streifen"
],
	"shape\u0000Plus\u0001": [
	"Kreuz"
],
	"shape\u0000Plaque\u0001": [
	"Zierrahmen"
],
	"shape\u0000Cylinder\u0001": [
	"Zylinder"
],
	"shape\u0000Cube\u0001": [
	"Würfel"
],
	"shape\u0000Funnel\u0001": [
	"Trichter"
],
	"shape\u0000Rectangle bevel\u0001": [
	"Abgeschrägtes Rechteck"
],
	"shape\u0000Ring\u0001": [
	"Rad"
],
	"shape\u0000No symbol\u0001": [
	"\"Nein\"-Symbol"
],
	"shape\u0000Block arc\u0001": [
	"Halbbogen"
],
	"shape\u0000Folded corner\u0001": [
	"Gefaltete Ecke"
],
	"shape\u0000Smiley face\u0001": [
	"Smiley"
],
	"shape\u0000Heart\u0001": [
	"Herz"
],
	"shape\u0000Lightning bolt\u0001": [
	"Gewitterblitz"
],
	"shape\u0000Sun\u0001": [
	"Sonne"
],
	"shape\u0000Moon\u0001": [
	"Mond"
],
	"shape\u0000Cloud\u0001": [
	"Wolke"
],
	"shape\u0000Arc\u0001": [
	"Bogen"
],
	"shape\u0000Double bracket\u0001": [
	"Eckige Klammer links / rechts"
],
	"shape\u0000Double brace\u0001": [
	"Geschweifte Klammer links / rechts"
],
	"shape\u0000Left bracket\u0001": [
	"Runde Klammer links"
],
	"shape\u0000Right bracket\u0001": [
	"Runde Klammer rechts"
],
	"shape\u0000Left brace\u0001": [
	"Geschweifte Klammer links"
],
	"shape\u0000Right brace\u0001": [
	"Geschweifte Klammer rechts"
],
	"shape\u0000Square tabs\u0001": [
	"Quadratische Rahmenpunkte"
],
	"shape\u0000Corner tabs\u0001": [
	"Dreieckige Rahmenpunkte"
],
	"shape\u0000Plaque tabs\u0001": [
	"Zierrahmeneckpunkte"
],
	"shape\u0000Quarter pie\u0001": [
	"Sektor"
],
	"shape\u0000Plus sign\u0001": [
	"Plus"
],
	"shape\u0000Times sign\u0001": [
	"Multiplikationszeichen"
],
	"shape\u0000Rectangles\u0001": [
	"Rechtecke"
],
	"shape\u0000Rectangle\u0001": [
	"Rechteck"
],
	"shape\u0000Rectangle: rounded corners\u0001": [
	"Abgerundetes Rechteck"
],
	"shape\u0000Rectangle: single corner snipped\u0001": [
	"Eine Ecke des Rechtecks schneiden"
],
	"shape\u0000Rectangle: top corners snipped\u0001": [
	"Oben liegende Ecken des Rechtecks schneiden"
],
	"shape\u0000Rectangle: diagonal corners snipped\u0001": [
	"Diagonal liegende Ecken des Rechtecks schneiden"
],
	"shape\u0000Rectangle: top corners one rounded one snipped\u0001": [
	"Eine oben liegende Ecke des Rechtecks abrunden, eine schneiden"
],
	"shape\u0000Rectangle: single corner rounded\u0001": [
	"Eine Ecke des Rechtecks abrunden"
],
	"shape\u0000Rectangle: top corners rounded\u0001": [
	"Oben liegende Ecken des Rechtecks abrunden"
],
	"shape\u0000Rectangle: diagonal corners rounded\u0001": [
	"Diagonal liegende Ecken des Rechtecks abrunden"
],
	"shape\u0000Block arrows\u0001": [
	"Blockpfeile"
],
	"shape\u0000Arrow: right\u0001": [
	"Pfeil nach rechts"
],
	"shape\u0000Arrow: left\u0001": [
	"Pfeil nach links"
],
	"shape\u0000Arrow: up\u0001": [
	"Pfeil nach oben"
],
	"shape\u0000Arrow: down\u0001": [
	"Pfeil nach unten"
],
	"shape\u0000Arrow: left-right\u0001": [
	"Pfeil nach links und rechts"
],
	"shape\u0000Arrow: up-down\u0001": [
	"Pfeil nach oben und unten"
],
	"shape\u0000Arrow: quad\u0001": [
	"Pfeil in vier Richtungen"
],
	"shape\u0000Arrow: left-right-up\u0001": [
	"Pfeil nach links, rechts und oben"
],
	"shape\u0000Arrow: right-bent\u0001": [
	"Rechteckiger Pfeil"
],
	"shape\u0000Arrow: u-turn\u0001": [
	"180-Grad-Pfeil"
],
	"shape\u0000Arrow: left-up\u0001": [
	"Pfeil nach links und oben"
],
	"shape\u0000Arrow: up-bent\u0001": [
	"Nach oben gebogener Pfeil"
],
	"shape\u0000Arrow: curved right\u0001": [
	"Nach rechts gekrümmter Pfeil"
],
	"shape\u0000Arrow: curved left\u0001": [
	"Nach links gekrümmter Pfeil"
],
	"shape\u0000Arrow: curved up\u0001": [
	"Nach oben gekrümmter Pfeil"
],
	"shape\u0000Arrow: curved down\u0001": [
	"Nach unten gekrümmter Pfeil"
],
	"shape\u0000Arrow: circular right\u0001": [
	"Nach oben gekrümmter Pfeil"
],
	"shape\u0000Arrow: circular left\u0001": [
	"Nach unten gekrümmter Pfeil"
],
	"shape\u0000Arrow: striped right\u0001": [
	"Gestreifter Pfeil nach rechts"
],
	"shape\u0000Arrow: notched right\u0001": [
	"Eingekerbter Pfeil nach rechts"
],
	"shape\u0000Arrow: pentagon\u0001": [
	"Richtungspfeil"
],
	"shape\u0000Arrow: chevron\u0001": [
	"Eingekerbter Richtungspfeil"
],
	"shape\u0000Arrow: swoosh\u0001": [
	"Geschwungener Pfeil"
],
	"shape\u0000Flow charts\u0001": [
	"Flussdiagramme"
],
	"shape\u0000Flowchart: process\u0001": [
	"Flussdiagramm: Prozess"
],
	"shape\u0000Flowchart: alternate process\u0001": [
	"Flussdiagramm: Alternativer Prozess"
],
	"shape\u0000Flowchart: decision\u0001": [
	"Flussdiagramm: Verzweigung"
],
	"shape\u0000Flowchart: data\u0001": [
	"Flussdiagramm: Daten"
],
	"shape\u0000Flowchart: predefined process\u0001": [
	"Flussdiagramm: Vordefinierter Prozess"
],
	"shape\u0000Flowchart: internal storage\u0001": [
	"Flussdiagramm: Zentralspeicher"
],
	"shape\u0000Flowchart: document\u0001": [
	"Flussdiagramm: Dokument"
],
	"shape\u0000Flowchart: multidocument\u0001": [
	"Flussdiagramm: Mehrere Dokumente"
],
	"shape\u0000Flowchart: terminator\u0001": [
	"Flussdiagramm: Grenzstelle"
],
	"shape\u0000Flowchart: preparation\u0001": [
	"Flussdiagramm: Vorbereitung"
],
	"shape\u0000Flowchart: manual input\u0001": [
	"Flussdiagramm: Manuelle Eingabe"
],
	"shape\u0000Flowchart: manual operation\u0001": [
	"Flussdiagramm: Manuelle Verarbeitung"
],
	"shape\u0000Flowchart: connector\u0001": [
	"Flussdiagramm: Verbindungsstelle"
],
	"shape\u0000Flowchart: off-page connector\u0001": [
	"Flussdiagramm: Verbindungsstelle zu einer anderen Seite"
],
	"shape\u0000Flowchart: Card\u0001": [
	"Flussdiagramm: Karte"
],
	"shape\u0000Flowchart: punched tape\u0001": [
	"Flussdiagramm: Lochstreifen"
],
	"shape\u0000Flowchart: summing junction\u0001": [
	"Flussdiagramm: Zusammenführung"
],
	"shape\u0000Flowchart: or\u0001": [
	"Flussdiagramm: Oder"
],
	"shape\u0000Flowchart: collate\u0001": [
	"Flussdiagramm: Zusammenstellen"
],
	"shape\u0000Flowchart: sort\u0001": [
	"Flussdiagramm: Sortieren"
],
	"shape\u0000Flowchart: extract\u0001": [
	"Flussdiagramm: Auszug"
],
	"shape\u0000Flowchart: merge\u0001": [
	"Flussdiagramm: Zusammenführen"
],
	"shape\u0000Flowchart: stored data\u0001": [
	"Flussdiagramm: Gespeicherte Daten"
],
	"shape\u0000Flowchart: delay\u0001": [
	"Flussdiagramm: Verzögerung"
],
	"shape\u0000Flowchart: magnetic tape\u0001": [
	"Flussdiagramm: Datenträger mit sequenziellem Zugriff"
],
	"shape\u0000Flowchart: magnetic disk\u0001": [
	"Flussdiagramm: Magnetplattenspeicher"
],
	"shape\u0000Flowchart: magnetic drum\u0001": [
	"Flussdiagramm: Datenträger mit direktem Zugriff"
],
	"shape\u0000Flowchart: display\u0001": [
	"Flussdiagramm: Anzeige"
],
	"shape\u0000Flowchart: offline storage\u0001": [
	"Flussdiagramm: Offline-Speicherung"
],
	"shape\u0000Stars and banners\u0001": [
	"Sterne und Banner"
],
	"shape\u0000Explosion: 12 points\u0001": [
	"Explosion 1"
],
	"shape\u0000Explosion: 14 points\u0001": [
	"Explosion 2"
],
	"shape\u0000Star: 4 points\u0001": [
	"Stern mit 4 Zacken"
],
	"shape\u0000Star: 5 points\u0001": [
	"Stern mit 5 Zacken"
],
	"shape\u0000Star: 6 points\u0001": [
	"Stern mit 6 Zacken"
],
	"shape\u0000Star: 7 points\u0001": [
	"Stern mit 7 Zacken"
],
	"shape\u0000Star: 8 points\u0001": [
	"Stern mit 8 Zacken"
],
	"shape\u0000Star: 10 points\u0001": [
	"Stern mit 10 Zacken"
],
	"shape\u0000Star: 12 points\u0001": [
	"Stern mit 12 Zacken"
],
	"shape\u0000Star: 16 points\u0001": [
	"Stern mit 16 Zacken"
],
	"shape\u0000Star: 24 points\u0001": [
	"Stern mit 24 Zacken"
],
	"shape\u0000Star: 32 points\u0001": [
	"Stern mit 32 Zacken"
],
	"shape\u0000Ribbon: tilted up\u0001": [
	"Band nach oben"
],
	"shape\u0000Ribbon: tilted down\u0001": [
	"Band nach unten"
],
	"shape\u0000Ribbon: curved and tilted up\u0001": [
	"Nach oben gekrümmtes Band"
],
	"shape\u0000Ribbon: curved and tilted down\u0001": [
	"Nach unten gekrümmtes Band"
],
	"shape\u0000Ribbon: left-right arrow\u0001": [
	"Band mit Pfeil nach links und rechts"
],
	"shape\u0000Scroll: vertical\u0001": [
	"Vertikaler Bildlauf"
],
	"shape\u0000Scroll: horizontal\u0001": [
	"Horizontaler Bildlauf"
],
	"shape\u0000Wave\u0001": [
	"Welle"
],
	"shape\u0000Double wave\u0001": [
	"Doppelte Welle"
],
	"shape\u0000Equation\u0001": [
	"Gleichung"
],
	"shape\u0000Minus sign\u0001": [
	"Minus"
],
	"shape\u0000Multiplication sign\u0001": [
	"Multiplizieren"
],
	"shape\u0000Division sign\u0001": [
	"Division"
],
	"shape\u0000Equal\u0001": [
	"Gleich"
],
	"shape\u0000Not equal\u0001": [
	"Ungleich"
],
	"shape\u0000Callouts\u0001": [
	"Legenden"
],
	"chart-type\u0000Column\u0001": [
	"Spalte"
],
	"chart-type\u0000Column (stacked)\u0001": [
	"Gestapelte Säule"
],
	"chart-type\u0000Column (percent)\u0001": [
	"Prozentsäule"
],
	"chart-type\u0000Bar\u0001": [
	"Balken"
],
	"chart-type\u0000Bar (stacked)\u0001": [
	"Gestapelter Balken"
],
	"chart-type\u0000Bar (percent)\u0001": [
	"Prozentbalken"
],
	"chart-type\u0000Line\u0001": [
	"Linie"
],
	"chart-type\u0000Line (curved)\u0001": [
	"Linie (interpoliert)"
],
	"chart-type\u0000Line (marker)\u0001": [
	"Linie mit Datenpunkten"
],
	"chart-type\u0000Scatter\u0001": [
	"Punkte mit geraden Linien"
],
	"chart-type\u0000Scatter (curved)\u0001": [
	"Punkte mit interpolierten Linien"
],
	"chart-type\u0000Scatter (marker)\u0001": [
	"Punkt (X/Y)"
],
	"chart-type\u0000Bubble\u0001": [
	"Blase"
],
	"chart-type\u0000Pie\u0001": [
	"Kreis"
],
	"chart-type\u0000Donut\u0001": [
	"Ring"
],
	"chart-type\u0000Area\u0001": [
	"Bereich"
],
	"chart-type\u0000Area (stacked)\u0001": [
	"Gestapelte Fläche"
],
	"chart-type\u0000Area (percent)\u0001": [
	"Prozentfläche"
],
	"drawing\u0000Insert an image\u0001": [
	"Bild einfügen"
],
	"drawing\u0000Delete\u0001": [
	"Löschen"
],
	"drawing\u0000Delete the drawing object\u0001": [
	"Zeichnung löschen"
],
	"drawing\u0000In front of text\u0001": [
	"Vor den Text"
],
	"drawing\u0000Format\u0001": [
	"Format"
],
	"drawing\u0000Format the drawing object\u0001": [
	"Zeichnungsobjekt formatieren"
],
	"drawing\u0000Group\u0001": [
	"Gruppieren"
],
	"drawing\u0000Group the selected drawings\u0001": [
	"Ausgewählte Zeichnungen gruppieren"
],
	"drawing\u0000Ungroup\u0001": [
	"Gruppierung aufheben"
],
	"drawing\u0000Ungroup the selected drawings\u0001": [
	"Gruppierung der ausgewählten Zeichnungen aufheben"
],
	"drawing\u0000Crop\u0001": [
	"Zuschneiden"
],
	"drawing\u0000Crop image\u0001": [
	"Bild zuschneiden"
],
	"drawing\u0000Insert a chart\u0001": [
	"Diagramm einfügen"
],
	"chart-format\u0000Data points\u0001": [
	"Datenpunkte"
],
	"chart-format\u0000Show data point labels\u0001": [
	"Datenpunktbezeichner anzeigen"
],
	"chart-format\u0000Vary colors by point\u0001": [
	"Punktfarbunterscheidung"
],
	"chart-format\u0000Labels\u0001": [
	"Bezeichner"
],
	"chart-format\u0000Settings for labels and axes\u0001": [
	"Einstellungen für Beschriftungen und Achsen"
],
	"menu-title\u0000X axis options\u0001": [
	"X-Achsenoptionen"
],
	"menu-title\u0000Y axis options\u0001": [
	"Y-Achsenoptionen"
],
	"menu-title\u0000Z axis options\u0001": [
	"Z-Achsenoptionen"
],
	"menu-title\u0000X axis title\u0001": [
	"X-Achsenbeschriftung"
],
	"menu-title\u0000Y axis title\u0001": [
	"Y-Achsenbeschriftung"
],
	"menu-title\u0000Z axis title\u0001": [
	"Z-Achsenbeschriftung"
],
	"chart-format\u0000Type text to add a title\u0001": [
	"Geben Sie einen Text zum Hinzufügen eines Titels ein"
],
	"menu-title\u0000Labels & Axes\u0001": [
	"Bezeichner & Achsen"
],
	"menu-title\u0000Chart title\u0001": [
	"Diagrammtitel"
],
	"chart-format\u0000Axis line\u0001": [
	"Achsenlinie"
],
	"chart-format\u0000Grid lines\u0001": [
	"Gitternetzlinien"
],
	"\u0000%1$s is being asked to grant you edit rights. This might take some time.\u0001": [
	"%1$s wird gebeten, Ihnen Bearbeitungsrechte zu gewähren. Dies kann einige Zeit in Anspruch nehmen."
],
	"\u0000The server is being asked to grant you edit rights. This might take some time.\u0001": [
	"Der Server wird aufgefordert, Ihnen Bearbeitungsrechte zu gewähren. Dies kann einige Zeit in Anspruch nehmen."
],
	"\u0000The request takes longer than expected, trying again.\u0001": [
	"Die Anfrage dauert länger als erwartet. Erneuter Versuch gestartet."
],
	"\u0000%1$s is asking for edit rights. This request will be accepted automatically in %2$d seconds.\u0001": [
	"%1$s möchte Bearbeitungsrechte. Diese Anfrage wird automatisch in %2$d Sekunden akzeptiert."
],
	"\u0000Decline\u0001": [
	"Ablehnen"
],
	"\u0000Accept\u0001": [
	"Übernehmen"
],
	"\u0000Your request for edit rights has been declined.\u0001": [
	"Ihre Anfrage nach Bearbeitungsrechten wurde abgelehnt."
],
	"\u0000Sorry, your document is very large. It will take some time to be loaded.\u0001": [
	"Ihr Dokument ist sehr groß. Das Laden wird leider etwas dauern."
],
	"\u0000Document in use\u0001": [
	"Dokument in Verwendung"
],
	"\u0000%1$s edits this document since %2$s on %3$s. To avoid data loss, please open the document on %3$s. Do you want to cancel opening it here?\u0001": [
	"%1$s bearbeitet dieses Dokument seit %2$s auf %3$s. Um Datenverlust zu vermeiden, öffnen Sie das Dokument bitte auf %3$s. Möchten Sie das Öffnen hier abbrechen?"
],
	"\u0000Another user edits this document since %1$s on %2$s. To avoid data loss, please open the document on %3$s. Do you want to cancel opening it here?\u0001": [
	"Ein anderer Benutzer bearbeitet dieses Dokument seit %1$s auf %2$s. Um Datenverluste zu vermeiden, öffnen Sie das Dokument bitte auf %3$s. Möchten Sie das Öffnen hier abbrechen?"
],
	"\u0000This document contains unsaved changes. Do you really want to close?\u0001": [
	"Dieses Dokument enthält nicht gesicherte Änderungen. Wollen Sie es wirklich schließen?"
],
	"\u0000The image could not be inserted.\u0001": [
	"Das Bild konnte nicht eingefügt werden."
],
	"\u0000You cannot insert this large image from an insecure page.\u0001": [
	"Sie können dieses große Bild nicht von einer unsicheren Seite aus einfügen."
],
	"\u0000Save as (encrypted)\u0001": [
	"Speichern unter (verschlüsselt)"
],
	"\u0000Save as\u0001": [
	"Speichern unter"
],
	"\u0000Copy of %1$s\u0001": [
	"Kopie von %1$s"
],
	"\u0000Save as template (%1$s)\u0001": [
	"Als Vorlage (%1$s) speichern"
],
	"\u0000Export as PDF\u0001": [
	"Als PDF exportieren"
],
	"\u0000What is AutoSave?\u0001": [
	"Was ist AutoSave?"
],
	"\u0000In OX Documents all your changes are saved automatically through AutoSave. It is not necessary to save your work manually.\u0001": [
	"In OX Documents werden Ihre Änderungen automatisch durch AutoSave gespeichert. Ein manuelles Speichern Ihrer Arbeit ist nicht nötig."
],
	"\u0000This document cannot be edited at the moment because a new version is being uploaded. Please wait until the upload is complete.\u0001": [
	"Dieses Dokument kann im Moment nicht bearbeitet werden, da eine neue Version hochgeladen wird. Bitte warten Sie, bis der Upload abgeschlossen ist."
],
	"\u0000New from template\u0001": [
	"Neu aus Vorlage"
],
	"\u0000Edit template\u0001": [
	"Vorlage bearbeiten"
],
	"\u0000Edit as new\u0001": [
	"Als neu bearbeiten"
],
	"\u0000Edit as new (encrypted)\u0001": [
	"Als neu bearbeiten (verschlüsselt)"
],
	"\u0000Present\u0001": [
	"Präsentieren"
],
	"\u0000Unnamed Style\u0001": [
	"Unbenannter Stil"
],
	"\u0000@mention or reply...\u0001": [
	"@erwähnen oder antworten..."
],
	"\u0000@mention or comment...\u0001": [
	"@erwähnen oder kommentieren..."
],
	"\u0000You added people to this comment. Attention: Due to missing permissions no email will be sent!\u0001": [
	"Sie haben Personen zu diesem Kommentar hinzugefügt. Achtung! Aufgrund fehlender Berechtigungen wird keine E-Mail verschickt."
],
	"\u0000You added people to this comment who will receive an email notification.\u0001": [
	"Sie haben diesem Kommentar Personen hinzugefügt, die per E-Mail benachrichtigt werden."
],
	"\u0000Please post your comment.\u0001": [
	"Bitte veröffentlichen Sie Ihren Kommentar."
],
	"comment-actions\u0000Send\u0001": [
	"Senden"
],
	"comment-actions\u0000Discard\u0001": [
	"Verwerfen"
],
	"\u0000Proceed\u0001": [
	"Fortfahren"
],
	"\u0000Cancel\u0001": [
	"Abbrechen"
],
	"\u0000This comment contains content this app cannot display. Editing may result in changing or losing that content. Click cancel if you do not want to risk it.\u0001": [
	"Dieser Kommentar enthält Inhalte, die diese App nicht anzeigen kann. Die Bearbeitung kann dazu führen, dass diese Inhalte geändert werden oder verloren gehen. Klicken Sie auf Abbrechen, wenn Sie dies nicht riskieren möchten."
],
	"\u0000Delete\u0001": [
	"Löschen"
],
	"\u0000Delete thread\u0001": [
	"Konversation löschen"
],
	"\u0000View %1$d more reply\u0001View %1$d more replies": [
	"%1$d weitere Antwort anzeigen",
	"%1$d weitere Antworten anzeigen"
],
	"\u0000Acquire edit rights\u0001": [
	"Bearbeitungsrechte anfordern"
],
	"borders\u0000Left border\u0001": [
	"Rahmenlinie links"
],
	"borders\u0000Right border\u0001": [
	"Rahmenlinie rechts"
],
	"borders\u0000Top border\u0001": [
	"Rahmenlinie oben"
],
	"borders\u0000Bottom border\u0001": [
	"Rahmenlinie unten"
],
	"borders\u0000Inner vertical borders\u0001": [
	"Vertikale Rahmenlinien innen"
],
	"borders\u0000Inner horizontal borders\u0001": [
	"Horizontale Rahmenlinien innen"
],
	"borders\u0000No borders\u0001": [
	"Kein Rahmen"
],
	"borders\u0000All borders\u0001": [
	"Alle Rahmenlinien"
],
	"borders\u0000Outer borders\u0001": [
	"Rahmenlinien außen"
],
	"borders\u0000Inner borders\u0001": [
	"Rahmenlinien innen"
],
	"borders\u0000Left and right borders\u0001": [
	"Rahmenlinien links und rechts"
],
	"borders\u0000Top and bottom borders\u0001": [
	"Rahmenlinien oben und unten"
],
	"borders\u0000All vertical borders\u0001": [
	"Alle vertikalen Rahmenlinien"
],
	"borders\u0000All horizontal borders\u0001": [
	"Alle horizontalen Rahmenlinien"
],
	"borders\u0000Inner vertical and outer borders\u0001": [
	"Innere vertikale und äußere Rahmenlinien"
],
	"borders\u0000Inner horizontal and outer borders\u0001": [
	"Innere horizontale und äußere Rahmenlinien"
],
	"borders\u0000Borders\u0001": [
	"Rahmen"
],
	"borders\u0000%1$d point\u0001%1$d points": [
	"%1$d Punkt",
	"%1$d Punkt"
],
	"\u0000Dark red\u0001": [
	"Dunkelrot"
],
	"\u0000Red\u0001": [
	"Rot"
],
	"\u0000Orange\u0001": [
	"Orange"
],
	"\u0000Yellow\u0001": [
	"Gelb"
],
	"\u0000Light green\u0001": [
	"Hellgrün"
],
	"\u0000Green\u0001": [
	"Grün"
],
	"\u0000Light blue\u0001": [
	"Hellblau"
],
	"\u0000Blue\u0001": [
	"Blau"
],
	"\u0000Dark blue\u0001": [
	"Dunkelblau"
],
	"\u0000Purple\u0001": [
	"Lila"
],
	"\u0000%1$s, lighter %2$d%\u0001": [
	"%1$s, %2$d% heller"
],
	"\u0000%1$s, darker %2$d%\u0001": [
	"%1$s, %2$d% dunkler"
],
	"\u0000No color\u0001": [
	"Keine Farbe"
],
	"\u0000Automatic color\u0001": [
	"Automatische Farbwahl"
],
	"\u0000Standard Colors\u0001": [
	"Standardfarben"
],
	"\u0000Theme Colors\u0001": [
	"Designfarben"
],
	"\u0000Rename document\u0001": [
	"Dokument umbenennen"
],
	"\u0000Document name\u0001": [
	"Dokumentname"
],
	"\u0000Font name\u0001": [
	"Schriftart"
],
	"font\u0000(Headings)\u0001": [
	"(Überschriften)"
],
	"font\u0000(Body)\u0001": [
	"(Textkörper)"
],
	"\u0000Font size\u0001": [
	"Schriftgröße"
],
	"\u0000Language\u0001": [
	"Sprache"
],
	"\u0000Text language\u0001": [
	"Textsprache"
],
	"language\u0000None\u0001": [
	"Keine"
],
	"\u0000New\u0001": [
	"Neu"
],
	"\u0000Recent documents and templates\u0001": [
	"Neueste Dokumente und Vorlagen"
],
	"\u0000Table size %1$s × %2$s\u0001": [
	"Tabellengröße %1$s × %2$s"
],
	"\u0000%1$d column\u0001%1$d columns": [
	"%1$d Spalte",
	"%1$d Spalten"
],
	"\u0000%1$d row\u0001%1$d rows": [
	"%1$d Zeile",
	"%1$d Zeilen"
],
	"text-doc\u0000Table\u0001": [
	"Tabelle"
],
	"text-doc\u0000Insert a table\u0001": [
	"Tabelle einfügen"
],
	"\u0000Table style\u0001": [
	"Tabellenstil"
],
	"\u0000Search\u0001": [
	"Suche"
],
	"\u0000Replace\u0001": [
	"Ersetzen"
],
	"\u0000Select a toolbar\u0001": [
	"Werkzeugleiste wählen"
],
	"\u0000Guest\u0001": [
	"Gast"
],
	"\u0000This user has edit rights for the document.\u0001": [
	"Dieser Benutzer hat Bearbeitungsrechte für das Dokument."
],
	"\u0000You have edit rights for the document.\u0001": [
	"Sie haben Bearbeitungsrechte für das Dokument."
],
	"\u0000Ctrl\u0001": [
	"Strg"
],
	"\u0000Cut, copy, and paste\u0001": [
	"Ausschneiden, kopieren und einfügen"
],
	"\u0000Some actions are unavailable via the context menu. Please use these shortcuts:\u0001": [
	"Einige Aktionen sind über das Kontextmenü nicht verfügbar. Bitte verwenden Sie diese Kurzbefehle:"
],
	"\u0000%1$s + X\u0001": [
	"%1$s + X"
],
	"\u0000%1$s + C\u0001": [
	"%1$s + C"
],
	"\u0000%1$s + V\u0001": [
	"%1$s + V"
],
	"\u0000You cannot use contacts in comments\u0001": [
	"Sie können keine Kontakte in Kommentaren verwenden"
],
	"\u0000You used a contact in a comment to send this contact a notification. This feature is not supported for your account. No notifications will be sent.\u0001": [
	"Sie haben einen Kontakt in einem Kommentar verwendet, um diesem Kontakt eine Benachrichtigung zu senden. Diese Funktion wird für Ihr Konto nicht unterstützt. Es werden keine Benachrichtigungen gesendet."
],
	"\u0000Comment anyway\u0001": [
	"Trotzdem kommentieren"
],
	"\u0000Share file \"%1$s\"\u0001": [
	"Datei \"%1$s\" freigeben"
],
	"\u0000These recipients do not have \"Reviewer\" permissions to this file. They will not be able to edit it unless you share the file with them. Every recipient gets an individual email.\u0001": [
	"Diese Empfänger haben keine \"Überarbeiter\"-Berechtigungen für diese Datei. Sie können sie nur bearbeiten, wenn Sie die Datei für sie freigeben. Jeder Empfänger erhält eine individuelle E-Mail."
],
	"\u0000Share\u0001": [
	"Freigeben"
],
	"\u0000Someone needs access to this file\u0001": [
	"Jemand benötigt Zugriff auf diese Datei"
],
	"\u0000These recipients do not have permissions to this file. Please contact the owner of the file to grant them permissions.\u0001": [
	"Diese Empfänger haben keine Berechtigungen für diese Datei. Wenden Sie sich bitte an den Besitzer der Datei, um ihnen Berechtigungen zu erteilen."
],
	"\u0000Internal user\u0001": [
	"Interner Benutzer"
],
	"\u0000Insert\u0001": [
	"Einfügen"
],
	"\u0000URL\u0001": [
	"URL"
],
	"\u0000Text\u0001": [
	"Text"
],
	"\u0000Remove\u0001": [
	"Entfernen"
],
	"\u0000Open\u0001": [
	"Öffnen"
],
	"\u0000There is an unposted comment in this document.\u0001": [
	"Dieses Dokument enthält einen unveröffentlichten Kommentar."
],
	"\u0000There is an unposted comment on this sheet.\u0001": [
	"Dieses Tabellenblatt enthält einen unveröffentlichten Kommentar."
],
	"\u0000There is an unposted comment on this slide.\u0001": [
	"Diese Folie enthält einen unveröffentlichten Kommentar."
],
	"\u0000You have added a comment that you have not yet posted. What do you want to do?\u0001": [
	"Sie haben einen Kommentar hinzugefügt, den Sie noch nicht veröffentlicht haben. Was möchten Sie tun?"
],
	"\u0000You have edited a comment that you have not yet posted. What do you want to do?\u0001": [
	"Sie haben einen Kommentar bearbeitet, den Sie noch nicht veröffentlicht haben. Was möchten Sie tun?"
],
	"\u0000Continue and discard comment\u0001": [
	"Fortfahren und Kommentar verwerfen"
],
	"\u0000Continue and discard edits\u0001": [
	"Fortfahren und Änderungen verwerfen"
],
	"\u0000Back to comment\u0001": [
	"Zurück zum Kommentar"
],
	"\u0000Text color\u0001": [
	"Textfarbe"
],
	"\u0000Fill color\u0001": [
	"Hintergrundfarbe"
],
	"\u0000Save in Drive\u0001": [
	"In Drive speichern"
],
	"\u0000Save as template\u0001": [
	"Als Vorlage speichern"
],
	"\u0000AutoSave\u0001": [
	"AutoSave"
],
	"menu-title\u0000File\u0001": [
	"Datei"
],
	"menu-title\u0000Format\u0001": [
	"Format"
],
	"menu-title\u0000Insert\u0001": [
	"Einfügen"
],
	"menu-title\u0000Font\u0001": [
	"Schrift"
],
	"menu-title\u0000Alignment\u0001": [
	"Ausrichtung"
],
	"menu-title\u0000Number format\u0001": [
	"Zahlenformat"
],
	"menu-title\u0000Slide\u0001": [
	"Folie"
],
	"menu-title\u0000Slide Show\u0001": [
	"Diashow"
],
	"menu-title\u0000Table\u0001": [
	"Tabelle"
],
	"menu-title\u0000Review\u0001": [
	"Überprüfen"
],
	"menu-title\u0000Comments\u0001": [
	"Kommentare"
],
	"menu-title\u0000Change tracking\u0001": [
	"Änderungsnachverfolgung"
],
	"menu-title\u0000Paragraph styles\u0001": [
	"Absatzstile"
],
	"menu-title\u0000Paragraph\u0001": [
	"Absatz"
],
	"menu-title\u0000List settings\u0001": [
	"Listeneinstellungen"
],
	"menu-title\u0000Font styles\u0001": [
	"Schriftvorlagen"
],
	"menu-title\u0000Cell border\u0001": [
	"Zellrahmen"
],
	"borders\u0000Cell borders\u0001": [
	"Zellrahmen"
],
	"borders\u0000Border color\u0001": [
	"Rahmenfarbe"
],
	"borders\u0000Border style\u0001": [
	"Rahmenstil"
],
	"borders\u0000Border width\u0001": [
	"Rahmenstärke"
],
	"\u0000Clear formatting\u0001": [
	"Formatierung löschen"
],
	"h-alignment\u0000Left\u0001": [
	"Linksbündig"
],
	"h-alignment\u0000Center\u0001": [
	"Zentriert"
],
	"h-alignment\u0000Right\u0001": [
	"Rechtsbündig"
],
	"h-alignment\u0000Justify\u0001": [
	"Blocksatz"
],
	"h-alignment\u0000Automatic\u0001": [
	"Automatisch"
],
	"v-alignment\u0000Top\u0001": [
	"Oben"
],
	"v-alignment\u0000Middle\u0001": [
	"Mitte"
],
	"v-alignment\u0000Bottom\u0001": [
	"Unten"
],
	"v-alignment\u0000Justify\u0001": [
	"Blocksatz"
],
	"\u0000Hyperlink\u0001": [
	"Hyperlink"
],
	"\u0000Edit hyperlink\u0001": [
	"Hyperlink bearbeiten"
],
	"\u0000Remove hyperlink\u0001": [
	"Hyperlink entfernen"
],
	"\u0000Open hyperlink\u0001": [
	"Hyperlink öffnen"
],
	"\u0000Insert hyperlink\u0001": [
	"Hyperlink einfügen"
],
	"\u0000Insert or edit a hyperlink\u0001": [
	"Hyperlink einfügen oder bearbeiten"
],
	"\u0000This hyperlink is invalid.\u0001": [
	"Dieser Hyperlink ist ungültig."
],
	"\u0000Revert last operation\u0001": [
	"Letzte Aktion rückgängig machen"
],
	"\u0000Restore last operation\u0001": [
	"Letzte Aktion wiederherstellen"
],
	"\u0000Comment\u0001": [
	"Kommentar"
],
	"\u0000Insert comment\u0001": [
	"Kommentar einfügen"
],
	"\u0000Write about\u0001": [
	"Schreiben über"
],
	"\u0000Create new content with AI\u0001": [
	"Neue Inhalte mit KI erstellen"
],
	"\u0000Rephrase\u0001": [
	"Umformulieren"
],
	"\u0000Rephrase content with AI\u0001": [
	"Inhalt mit KI umformulieren"
],
	"\u0000Summarize\u0001": [
	"Zusammenfassen"
],
	"\u0000Summarize content with AI\u0001": [
	"Inhalt mit KI zusammenfassen"
],
	"\u0000Translate\u0001": [
	"Übersetzen"
],
	"\u0000Translate content with AI\u0001": [
	"Inhalt mit KI übersetzen"
],
	"comment-actions\u0000Reply\u0001": [
	"Antworten"
],
	"comment-actions\u0000Reply to comment\u0001": [
	"Auf Kommentar antworten"
],
	"\u0000Cut\u0001": [
	"Ausschneiden"
],
	"\u0000Cut to clipboard\u0001": [
	"Ausschneiden und in der Zwischenablage speichern"
],
	"\u0000Copy\u0001": [
	"Kopieren"
],
	"\u0000Copy to clipboard\u0001": [
	"In die Zwischenablage kopieren"
],
	"\u0000Paste\u0001": [
	"Einfügen"
],
	"\u0000Paste from clipboard\u0001": [
	"Aus Zwischenablage einfügen"
],
	"\u0000Delete contents\u0001": [
	"Inhalte löschen"
],
	"\u0000Deleting the selected elements cannot be undone. Do you want to continue?\u0001": [
	"Das Löschen der markierten Objekte kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?"
],
	"\u0000Delete rows\u0001": [
	"Zeilen löschen"
],
	"\u0000Deleting the selected rows cannot be undone. Do you want to continue?\u0001": [
	"Das Löschen der markierten Zeilen kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?"
],
	"\u0000Delete columns\u0001": [
	"Spalten löschen"
],
	"\u0000Deleting the selected columns cannot be undone. Do you want to continue?\u0001": [
	"Das Löschen der markierten Spalten kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?"
],
	"\u0000Bold\u0001": [
	"Fett"
],
	"\u0000Italic\u0001": [
	"Kursiv"
],
	"\u0000Underline\u0001": [
	"Unterstrichen"
],
	"\u0000Strike through\u0001": [
	"Durchgestrichen"
],
	"\u0000Show toolbars\u0001": [
	"Werkzeugleisten einblenden"
],
	"\u0000Show or hide the toolbars\u0001": [
	"Werkzeugleisten ein- oder ausblenden"
],
	"\u0000Show comments\u0001": [
	"Kommentare anzeigen"
],
	"\u0000Show or hide the comments\u0001": [
	"Kommentare ein- oder ausblenden"
],
	"\u0000Show sidebar\u0001": [
	"Seitenleiste einblenden"
],
	"\u0000Show or hide the sidebar\u0001": [
	"Seitenleiste ein- oder ausblenden"
],
	"\u0000Show collaborators\u0001": [
	"Bearbeiter einblenden"
],
	"\u0000Show or hide list of collaborators\u0001": [
	"Liste der Bearbeiter ein- oder ausblenden"
],
	"\u0000Text %1$d\u0001": [
	"Text %1$d"
],
	"\u0000Background %1$d\u0001": [
	"Hintergrund %1$d"
],
	"\u0000Accent %1$d\u0001": [
	"Akzent %1$d"
],
	"\u0000Replace all\u0001": [
	"Alle ersetzen"
],
	"\u0000All\u0001": [
	"Alle"
],
	"\u0000Search ...\u0001": [
	"Suchen ..."
],
	"\u0000Find text\u0001": [
	"Text suchen"
],
	"\u0000%1$d result found\u0001%1$d results found": [
	"%1$d Ergebnis gefunden",
	"%1$d Ergebnisse gefunden"
],
	"\u0000More than 99 results found\u0001": [
	"Mehr als 99 Ergebnisse gefunden"
],
	"\u0000Replace with ...\u0001": [
	"Ersetzen durch..."
],
	"\u0000Replacement text\u0001": [
	"Ersetzungstext"
],
	"\u0000Start search\u0001": [
	"Suche starten"
],
	"\u0000Select previous search result\u0001": [
	"Vorheriges Suchergebnis wählen"
],
	"\u0000Select next search result\u0001": [
	"Nächstes Suchergebnis wählen"
],
	"\u0000Replace selected search result and select the next result\u0001": [
	"Gewähltes Suchergebnis ersetzen und nächstes Ergebnis wählen"
],
	"\u0000Replace all search results\u0001": [
	"Alle Suchergebnisse ersetzen"
],
	"\u0000Your document contains unposted comments.\u0001": [
	"Ihr Dokument enthält unveröffentlichte Kommentare."
],
	"\u0000Loading document\u0001": [
	"Das Dokument wird geladen"
],
	"\u0000Saving changes\u0001": [
	"Änderungen speichern"
],
	"\u0000All changes saved\u0001": [
	"Alle Änderungen wurden gespeichert"
],
	"\u0000Slide settings\u0001": [
	"Folieneinstellungen"
],
	"\u0000Page settings\u0001": [
	"Seiteneinstellungen"
],
	"\u0000Actions\u0001": [
	"Aktionen"
],
	"\u0000Share / Permissions\u0001": [
	"Freigeben / Berechtigungen"
],
	"\u0000Document is encrypted\u0001": [
	"Dokument ist verschlüsselt"
],
	"\u0000Toggle search\u0001": [
	"Suche an/aus"
],
	"\u0000Collaborators\u0001": [
	"Bearbeiter"
],
	"\u0000List of collaborators of this document\u0001": [
	"Liste der Bearbeiter des Dokuments"
],
	"comment-actions\u0000Hide comments pane\u0001": [
	"Kommentarbereich ausblenden"
],
	"\u0000Search recent documents\u0001": [
	"In neuesten Dokumenten suchen"
],
	"\u0000Show in Drive\u0001": [
	"In Drive anzeigen"
],
	"\u0000Remove from list\u0001": [
	"Aus Liste entfernen"
],
	"\u0000Clear list\u0001": [
	"Liste löschen"
],
	"\u0000New from template (encrypted)\u0001": [
	"Neu aus Vorlage (verschlüsselt)"
],
	"\u0000Delete template\u0001": [
	"Vorlage löschen"
],
	"\u0000System template\u0001": [
	"Systemvorlage"
],
	"\u0000Global template\u0001": [
	"Globale Vorlage"
],
	"\u0000User template\u0001": [
	"Benutzervorlage"
],
	"\u0000Blank text document\u0001": [
	"Leeres Textdokument"
],
	"\u0000New text document\u0001": [
	"Neues Textdokument"
],
	"\u0000New text document (encrypted)\u0001": [
	"Neues Textdokument (verschlüsselt)"
],
	"\u0000Blank spreadsheet\u0001": [
	"Leeres Tabellendokument"
],
	"\u0000New spreadsheet\u0001": [
	"Neues Tabellendokument"
],
	"\u0000New spreadsheet (encrypted)\u0001": [
	"Neues Tabellendokument (verschlüsselt)"
],
	"\u0000Blank presentation\u0001": [
	"Leere Präsentation"
],
	"\u0000New presentation\u0001": [
	"Neue Präsentation"
],
	"\u0000New presentation (encrypted)\u0001": [
	"Neue Präsentation (verschlüsselt)"
],
	"\u0000Recent Documents\u0001": [
	"Neueste Dokumente"
],
	"\u0000New from Template\u0001": [
	"Neu aus Vorlage"
],
	"\u0000Drop template files here for upload\u0001": [
	"Zum Hochladen Vorlagedateien hier ablegen"
],
	"tour\u0000Toolbar\u0001": [
	"Werkzeugleiste"
],
	"tour\u0000At the top of the screen you will find the toolbar which shows all the common functions.\u0001": [
	"Oben im Fenster finden Sie die Werkzeugleiste mit allen gängigen Funktionen."
],
	"tour\u0000Autosaving changes\u0001": [
	"Änderungen automatisch speichern"
],
	"tour\u0000Changes are saved automatically whenever you work on your document.\u0001": [
	"Änderungen werden automatisch gespeichert, sobald Sie an Ihrem Dokument arbeiten."
],
	"tour\u0000File tab\u0001": [
	"Reiter \"Datei\""
],
	"tour\u0000The file tab offers you various ways to share or save your document.\u0001": [
	"Der Reiter \"Datei\" bietet Ihnen zahlreiche Möglichkeiten zum Freigeben oder Speichern Ihres Dokuments."
],
	"tour\u0000Saving options\u0001": [
	"Speicheroptionen"
],
	"tour\u0000If you would like to store your document in a specific folder, just click on \"Save as\".\u0001": [
	"Wenn Sie Ihr Dokument in einem bestimmten Ordner speichern möchten, klicken Sie einfach auf \"Speichern unter\"."
],
	"tour\u0000You can also click on \"Save as template\" to create your own templates.\u0001": [
	"Sie können auch auf  \"Als Vorlage speichern\" klicken, um Ihre eigenen Vorlagen zu erstellen."
],
	"tour\u0000Sending your document\u0001": [
	"Ihr Dokument versenden"
],
	"tour\u0000Sending your document by email is easy. Just click on the mail icon and you are ready to go!\u0001": [
	"Das Versenden Ihres Dokuments per E-Mail ist ganz einfach. Sie müssen nur auf das E-Mail-Symbol klicken und schon sind Sie startbereit!"
],
	"tour\u0000Closing document\u0001": [
	"Dokument schließen"
],
	"tour\u0000The document can be closed now. As all changes are stored automatically, you do not need to save documents manually.\u0001": [
	"Das Dokument kann nun geschlossen werden. Alle Änderungen werden automatisch gespeichert. Sie müssen kein Dokument manuell speichern."
],
	"tour\u0000Restart Guided Tour\u0001": [
	"Guided Tour neu starten"
],
	"tour\u0000Hint: you can start guided tours, any time you need them, from the system menu.\u0001": [
	"Tipp: Sie können die Guided Tours jederzeit bei Bedarf vom Systemmenü aus starten."
],
	"\u0000unknown\u0001": [
	"unbekannt"
],
	"\u0000The file cannot be uploaded as this is not a supported template.\u0001": [
	"Die Datei kann nicht hochgeladen werden, da es sich um eine nicht unterstützte Vorlage handelt."
],
	"\u0000Some files could not be uploaded as they are not supported templates.\u0001": [
	"Einige Dateien konnten nicht hochgeladen werden, da es sich um nicht unterstützte Vorlagen handelt."
],
	"tour\u0000The Presentation app\u0001": [
	"Die Präsentations-App"
],
	"tour\u0000Welcome to your new Presentation app. This Guided Tour will introduce you to the most important functions of creating and editing presentations online.\u0001": [
	"Willkommen bei Ihrer neuen Präsentations-App. Diese Guided Tour führt Sie in die wichtigsten Funktionen zur Online-Erstellung und -Bearbeitung von Präsentationen ein."
],
	"tour\u0000Templates\u0001": [
	"Vorlagen"
],
	"tour\u0000Clicking on the Presentation app in the navigation bar displays an overview of all the templates available to you in Presentation.\u0001": [
	"Wenn Sie auf die Präsentations-App in der Navigationsleiste klicken, erhalten Sie einen Überblick über alle für Sie verfügbaren Vorlagen in \"Präsentation\"."
],
	"tour\u0000Blank presentation\u0001": [
	"Leere Präsentation"
],
	"tour\u0000You can choose from a variety of templates to help you create professional presentations.\u0001": [
	"Sie können aus einer Vielzahl von Vorlagen zum Erstellen professioneller Präsentationen wählen."
],
	"tour\u0000Let's start with a blank presentation.\u0001": [
	"Beginnen wir mit einer leeren Präsentation."
],
	"tour\u0000New slides\u0001": [
	"Neue Folien"
],
	"tour\u0000With a click on \"Slide\" you can add new slides to your presentation. Choose \"Layout\" to change the design of the selected slide. Depending on your template, many different layouts and slide types are available to you.\u0001": [
	"Mit einem Klick auf \"Folie\" können Sie Ihrer Präsentation neue Folien hinzufügen. Zum Ändern des Designs der ausgewählten Folie wählen Sie \"Layout\". Je nach Ihrer Vorlage stehen Ihnen viele verschiedene Layouts und Folientypen zur Verfügung."
],
	"tour\u0000Edit master\u0001": [
	"Masterfolie bearbeiten"
],
	"tour\u0000You can create and edit the layout of your slides by clicking on \"Edit master\". While editing your master slides, you are able to change back to edit your normal slides by clicking on \"Edit normal\".\u0001": [
	"Sie können das Layout Ihrer Folien erstellen und bearbeiten, indem Sie auf \"Masterfolie bearbeiten\" klicken. Während der Bearbeitung Ihrer Masterfolien können Sie zurückwechseln, um Ihre normalen Folien zu bearbeiten, indem Sie auf \"Normale Folien bearbeiten\" klicken."
],
	"tour\u0000Present slides\u0001": [
	"Folien präsentieren"
],
	"tour\u0000With a click on \"Present\" you can start a presentation of your slides right away.\u0001": [
	"Mit einem Klick auf \"Präsentieren\" können Sie sofort mit der Präsentation der Folien beginnen."
],
	"tour\u0000The Spreadsheet app\u0001": [
	"Die Tabellen-App"
],
	"tour\u0000Welcome to your new Spreadsheet app. This Guided Tour will introduce you to the most important functions of creating and editing spreadsheets online.\u0001": [
	"Willkommen bei Ihrer neuen Tabellen-App. Diese Guided Tour führt Sie in die wichtigsten Funktionen zur Online-Erstellung und -Bearbeitung von Tabellendokumenten ein."
],
	"tour\u0000Clicking on the Spreadsheet app in the navigation bar displays an overview of all the templates available to you in Spreadsheet.\u0001": [
	"Wenn Sie auf die Tabellen-App in der Navigationsleiste klicken, erhalten Sie einen Überblick über alle für Sie verfügbaren Vorlagen in \"Tabelle\"."
],
	"tour\u0000Blank spreadsheet\u0001": [
	"Leeres Tabellendokument"
],
	"tour\u0000You can choose from a variety of templates to help you create professional documents.\u0001": [
	"Sie können aus einer Vielzahl von Vorlagen zum Erstellen professioneller Dokumente wählen."
],
	"tour\u0000Let's start with a blank document.\u0001": [
	"Beginnen wir mit einem leeren Dokument."
],
	"tour\u0000Formulas\u0001": [
	"Formeln"
],
	"tour\u0000You can use all the regular spreadsheet formulas by typing them into a cell.\u0001": [
	"Sie können alle regulären Tabellenformeln verwenden, indem Sie sie in eine Zelle eingeben."
],
	"tour\u0000Autocompletion\u0001": [
	"Autovervollständigung"
],
	"tour\u0000As soon as you start typing a formula, autocompletion offers you a list of matching functions to choose from.\u0001": [
	"Sobald Sie beginnen, eine Formel einzugeben, wird Ihnen durch die Autovervollständigung eine Liste passender Funktionen zur Auswahl angeboten."
],
	"tour\u0000Displaying hidden formulas\u0001": [
	"Versteckte Formeln anzeigen"
],
	"tour\u0000If a result is displayed in a cell, the calculating formula will be displayed in the formula bar.\u0001": [
	"Wenn ein Ergebnis in einer Zelle angezeigt wird, wird die Berechnungsformel in der Formelleiste angezeigt."
],
	"tour\u0000The Text app\u0001": [
	"Die Text-App"
],
	"tour\u0000Welcome to your new Text app. This Guided Tour will introduce you to the most important functions of creating and editing text documents online.\u0001": [
	"Willkommen bei Ihrer neuen Text-App. Diese Guided Tour führt Sie in die wichtigsten Funktionen zur Online-Erstellung und -Bearbeitung von Textdokumenten ein."
],
	"tour\u0000Clicking on the Text app in the navigation bar displays an overview of all the templates available to you in Text.\u0001": [
	"Wenn Sie auf die Text-App in der Navigationsleiste klicken, erhalten Sie einen Überblick über alle für Sie verfügbaren Vorlagen in \"Text\"."
],
	"tour\u0000Blank text document\u0001": [
	"Leeres Textdokument"
],
	"\u0000You have no recent documents.\u0001": [
	"Sie haben keine zuletzt verwendeten Dokumente."
],
	"\u0000(no format)\u0001": [
	"(kein Format)"
],
	"\u0000Sorry, updating of all fields in document will take some time.\u0001": [
	"Das Aktualisieren aller Felder im Dokument wird leider etwas dauern."
],
	"\u0000Applying footer fields to all slides, please wait...\u0001": [
	"Fußzeilenfelder werden auf alle Folien angewendet. Bitte warten ..."
],
	"\u0000Applying footer fields to current layout and all following standard slides, please wait...\u0001": [
	"Fußzeilenfelder werden auf das aktuelle Layout und alle folgenden Standardfolien angewendet. Bitte warten ..."
],
	"\u0000Click to leave presentation ...\u0001": [
	"Klicken Sie hier, um die Präsentation zu verlassen ..."
],
	"\u0000Delete comments\u0001": [
	"Kommentare löschen"
],
	"\u0000All comments in this presentation will be removed. Do you want to continue?\u0001": [
	"Alle Kommentare in dieser Präsentation werden entfernt. Möchten Sie fortfahren?"
],
	"\u0000The search continues from the end of this presentation.\u0001": [
	"Die Suche wird am Ende dieser Präsentation fortgesetzt."
],
	"\u0000The search continues from the beginning of this presentation.\u0001": [
	"Die Suche wird am Anfang dieser Präsentation fortgesetzt."
],
	"\u0000Searching for a thread did fail.\u0001": [
	"Die Suche nach einer Konversation ist fehlgeschlagen."
],
	"\u0000Insert table\u0001": [
	"Tabelle einfügen"
],
	"\u0000Insert media clip\u0001": [
	"Medienclip einfügen"
],
	"\u0000Insert chart\u0001": [
	"Diagramm einfügen"
],
	"\u0000Insert online image\u0001": [
	"Online-Bild einfügen"
],
	"\u0000Insert smart art graphic\u0001": [
	"SmartArt-Grafik einfügen"
],
	"\u0000This document contains slide background images which can't be displayed: %s\u0001": [
	"Dieses Dokument enthält Folienhintergrundbilder, die nicht angezeigt werden können: %s"
],
	"\u0000Audio and video are not supported yet.\u0001": [
	"Audio und Video werden derzeit nicht unterstützt."
],
	"\u0000Applying changes, please wait...\u0001": [
	"Änderungen werden übernommen. Bitte warten..."
],
	"\u0000Connector functionality is disabled because of too many drawings on current slide.\u0001": [
	"Konnektor-Funktionalität ist wegen zu vieler Zeichnungen auf der aktuellen Folie deaktiviert."
],
	"\u0000Blank Slide\u0001": [
	"Leere Folie"
],
	"\u0000Title Slide\u0001": [
	"Titelfolie"
],
	"\u0000Title, Content\u0001": [
	"Titel, Inhalt"
],
	"\u0000Title and 2 Contents\u0001": [
	"Titel und 2 Inhalte"
],
	"\u0000Title Only\u0001": [
	"nur Titel"
],
	"\u0000Centered Text\u0001": [
	"Zentrierter Text"
],
	"\u0000Title, 2 Contents and Content\u0001": [
	"Titel, 2 Inhalte und Inhalt"
],
	"\u0000Title, Content and 2 Contents\u0001": [
	"Titel, Inhalt und 2 Inhalte"
],
	"\u0000Title, 2 Contents over Content\u0001": [
	"Titel, 2 Inhalte über Inhalt"
],
	"\u0000Title, Content over Content\u0001": [
	"Titel, Inhalt über Inhalt"
],
	"\u0000Title, 4 Contents\u0001": [
	"Titel, 4 Inhalte"
],
	"\u0000Title, 6 Contents\u0001": [
	"Titel, 6 Inhalte"
],
	"\u0000Vertical Title, Vertical Text\u0001": [
	"Vertikaler Titel, vertikaler Text"
],
	"\u0000Title, Vertical Text\u0001": [
	"Titel, vertikaler Text"
],
	"\u0000Duplicating selected slides, please wait...\u0001": [
	"Ausgewählte Folien werden dupliziert. Bitte warten ..."
],
	"\u0000Applying background to all slides, please wait...\u0001": [
	"Hintergrund wird auf alle Folien angewendet. Bitte warten ..."
],
	"\u0000Click to add text\u0001": [
	"Zum Hinzufügen von Text bitte klicken"
],
	"\u0000Click to add title\u0001": [
	"Zum Hinzufügen eines Titels bitte klicken"
],
	"\u0000Click to add subtitle\u0001": [
	"Zum Hinzufügen eines Untertitels bitte klicken"
],
	"\u0000Media clip\u0001": [
	"Medienclip"
],
	"\u0000Online image\u0001": [
	"Online-Bild"
],
	"\u0000Chart\u0001": [
	"Diagramm"
],
	"\u0000Smart Art\u0001": [
	"SmartArt"
],
	"\u0000Click to add table\u0001": [
	"Zum Hinzufügen einer Tabelle bitte klicken"
],
	"\u0000Click to add image\u0001": [
	"Zum Hinzufügen eines Bildes bitte klicken"
],
	"\u0000Slide Number\u0001": [
	"Foliennummer"
],
	"\u0000Footer\u0001": [
	"Fußzeile"
],
	"\u0000Date\u0001": [
	"Datum"
],
	"\u0000Click icon to add image\u0001": [
	"Zum Hinzufügen eines Bildes bitte auf das Symbol klicken"
],
	"\u0000Click icon to add table\u0001": [
	"Zum Hinzufügen einer Tabelle bitte auf das Symbol klicken"
],
	"\u0000Click icon to add chart\u0001": [
	"Zum Hinzufügen eines Diagramms bitte auf das Symbol klicken"
],
	"\u0000Click icon to add smart art graphic\u0001": [
	"Zum Hinzufügen einer SmartArt-Grafik bitte auf das Symbol klicken"
],
	"\u0000Click icon to add clip art\u0001": [
	"Zum Hinzufügen eines ClipArts bitte auf das Symbol klicken"
],
	"\u0000Click icon to add media\u0001": [
	"Zum Hinzufügen von Medien bitte auf das Symbol klicken"
],
	"\u0000Content placeholder\u0001": [
	"Platzhalter für Inhalt"
],
	"\u0000Vertical content placeholder\u0001": [
	"Platzhalter für vertikalen Inhalt"
],
	"\u0000Text placeholder\u0001": [
	"Platzhalter für Text"
],
	"\u0000Vertical text placeholder\u0001": [
	"Platzhalter für vertikalen Text"
],
	"\u0000Image placeholder\u0001": [
	"Platzhalter für Bild"
],
	"\u0000Table placeholder\u0001": [
	"Platzhalter für Tabelle"
],
	"\u0000Edit Master text styles\u0001": [
	"Textmasterformate bearbeiten"
],
	"\u0000Second level\u0001": [
	"Zweite Ebene"
],
	"\u0000Third level\u0001": [
	"Dritte Ebene"
],
	"\u0000Fourth level\u0001": [
	"Vierte Ebene"
],
	"\u0000Fifth level\u0001": [
	"Fünfte Ebene"
],
	"\u0000Click to edit Master title style\u0001": [
	"Zum Bearbeiten des Titelmasterformats bitte klicken"
],
	"\u0000There are no comments on this slide.\u0001": [
	"Diese Folie enthält keine Kommentare."
],
	"\u0000Animations\u0001": [
	"Animationen"
],
	"\u0000Select a slide animation for the slide changes\u0001": [
	"Eine Folienanimation für den Folienübergang wählen"
],
	"\u0000No animation\u0001": [
	"Keine Animation"
],
	"\u0000No slide animation\u0001": [
	"Keine Folienanimation"
],
	"\u0000Start with first slide\u0001": [
	"Mit erster Folie beginnen"
],
	"\u0000Start the presentation with the first slide\u0001": [
	"Präsentation mit erster Folie beginnen"
],
	"\u0000Start with current slide\u0001": [
	"Mit aktueller Folie beginnen"
],
	"\u0000Start the presentation with the current slide\u0001": [
	"Präsentation mit aktueller Folie beginnen"
],
	"\u0000Slide\u0001": [
	"Folie"
],
	"\u0000Insert new slide\u0001": [
	"Neue Folie einfügen"
],
	"\u0000Layout\u0001": [
	"Layout"
],
	"\u0000Change layout\u0001": [
	"Layout ändern"
],
	"\u0000Edit master\u0001": [
	"Masterfolie bearbeiten"
],
	"\u0000Edit normal\u0001": [
	"Normale Folien bearbeiten"
],
	"\u0000Switch between editing master/layout slides and normal slides\u0001": [
	"Zwischen dem Bearbeiten von Master-/Layoutfolien und normalen Folien umschalten"
],
	"\u0000Placeholder\u0001": [
	"Platzhalter"
],
	"\u0000Insert placeholder\u0001": [
	"Platzhalter einfügen"
],
	"\u0000Date/Time object\u0001": [
	"Datum/Uhrzeit-Platzhalter"
],
	"\u0000Show or hide date and time placeholder object\u0001": [
	"Platzhalterobjekt für Datum und Uhrzeit ein- oder ausblenden"
],
	"\u0000Footer object\u0001": [
	"Fußzeilenobjekt"
],
	"\u0000Show or hide footer placeholder objects\u0001": [
	"Fußzeilenplatzhalter ein- oder ausblenden"
],
	"\u0000Slide number object\u0001": [
	"Foliennummer-Objekt"
],
	"\u0000Show or hide slide number object\u0001": [
	"Foliennummerobjekt ein- oder ausblenden"
],
	"\u0000Title\u0001": [
	"Titel"
],
	"\u0000Show or hide title placeholder object\u0001": [
	"Titelplatzhalter ein- oder ausblenden"
],
	"\u0000Text body\u0001": [
	"Textkörper"
],
	"\u0000Show or hide text body placeholder object\u0001": [
	"Textkörperplatzhalter ein- oder ausblenden"
],
	"\u0000Footer objects\u0001": [
	"Fußzeilenobjekte"
],
	"\u0000Content\u0001": [
	"Inhalt"
],
	"\u0000Content vertical\u0001": [
	"Vertikaler Inhalt"
],
	"\u0000Text vertical\u0001": [
	"Vertikaler Text"
],
	"\u0000Table\u0001": [
	"Tabelle"
],
	"\u0000Field\u0001": [
	"Feld"
],
	"\u0000Insert field\u0001": [
	"Feld einfügen"
],
	"\u0000Slide number\u0001": [
	"Foliennummer"
],
	"\u0000Date & time\u0001": [
	"Datum & Zeit"
],
	"\u0000Choose\u0001": [
	"Wählen"
],
	"\u0000Line\u0001": [
	"Linie"
],
	"\u0000Color\u0001": [
	"Farbe"
],
	"\u0000Style\u0001": [
	"Stil"
],
	"\u0000Arrow\u0001": [
	"Pfeil"
],
	"\u0000No background\u0001": [
	"Kein Hintergrund"
],
	"\u0000Transparency\u0001": [
	"Transparenz"
],
	"\u0000Date and time\u0001": [
	"Datum und Zeit"
],
	"field-dialog\u0000Select format\u0001": [
	"Format wählen"
],
	"\u0000Update automatically\u0001": [
	"Automatisch aktualisieren"
],
	"\u0000Apply\u0001": [
	"Anwenden"
],
	"\u0000Fixed date\u0001": [
	"Festes Datum"
],
	"\u0000Apply to all\u0001": [
	"Auf alle anwenden"
],
	"\u0000Background\u0001": [
	"Hintergrund"
],
	"\u0000Hide background graphics\u0001": [
	"Hintergrundgrafiken ausblenden"
],
	"\u0000used by slide\u0001": [
	"verwendet von Folie"
],
	"\u0000used by slides\u0001": [
	"verwendet von Folien"
],
	"\u0000You are in the slide master view.\u0001": [
	"Sie befinden sich in der Masterfolienansicht."
],
	"\u0000Leave slide master view\u0001": [
	"Masterfolienansicht verlassen"
],
	"\u0000Set slide background\u0001": [
	"Folienhintergrund festlegen"
],
	"\u0000Format slide background\u0001": [
	"Folienhintergrund formatieren"
],
	"\u0000Start the Presenter\u0001": [
	"Presenter starten"
],
	"\u0000Delete this thread\u0001": [
	"Diese Konversation löschen"
],
	"\u0000Insert slide\u0001": [
	"Folie einfügen"
],
	"\u0000Insert layout slide\u0001": [
	"Layout-Folie einfügen"
],
	"\u0000Duplicate slide\u0001": [
	"Folie duplizieren"
],
	"\u0000Delete slide\u0001": [
	"Folie löschen"
],
	"\u0000Hide slide\u0001": [
	"Folie ausblenden"
],
	"\u0000Unhide slide\u0001": [
	"Folie einblenden"
],
	"\u0000Change master\u0001": [
	"Master wechseln"
],
	"comment-actions\u0000Previous\u0001": [
	"Zurück"
],
	"comment-actions\u0000Go to previous comment\u0001": [
	"Zum vorherigen Kommentar"
],
	"comment-actions\u0000Next\u0001": [
	"Weiter"
],
	"comment-actions\u0000Go to next comment\u0001": [
	"Zum nächsten Kommentar"
],
	"comment-actions\u0000Delete\u0001": [
	"Löschen"
],
	"comment-actions\u0000Delete selected thread\u0001": [
	"Gewählte Kommentarkonversation löschen"
],
	"comment-actions\u0000Delete all\u0001": [
	"Alle löschen"
],
	"comment-actions\u0000Delete every comment\u0001": [
	"Jeden Kommentar löschen"
],
	"\u0000The table reached its maximum size. You cannot insert further rows.\u0001": [
	"Die Tabelle hat ihre maximale Größe erreicht. Sie können keine weiteren Zeilen einfügen."
],
	"\u0000The table reached its maximum size. You cannot insert further columns.\u0001": [
	"Die Tabelle hat ihre maximale Größe erreicht. Sie können keine weiteren Spalten einfügen."
],
	"\u0000Views\u0001": [
	"Ansichten"
],
	"\u0000View master\u0001": [
	"Master anzeigen"
],
	"\u0000View master & layout slides\u0001": [
	"Master- & Layout-Folien anzeigen"
],
	"\u0000Insert Drawing\u0001": [
	"Zeichnung einfügen"
],
	"\u0000Tab stop\u0001": [
	"Tabulator"
],
	"\u0000Insert tab stop\u0001": [
	"Tabulator einfügen"
],
	"\u0000Duplicate\u0001": [
	"Duplizieren"
],
	"\u0000Duplicate selected slides\u0001": [
	"Ausgewählte Folien duplizieren"
],
	"\u0000Hide\u0001": [
	"Ausblenden"
],
	"\u0000Start presentation\u0001": [
	"Präsentation starten"
],
	"\u0000Start the presentation\u0001": [
	"Die Präsentation starten"
],
	"\u0000Full screen\u0001": [
	"Vollbild"
],
	"\u0000Show the presentation in full screen mode\u0001": [
	"Präsentation im Vollbildmodus anzeigen"
],
	"\u0000Check spelling\u0001": [
	"Rechtschreibung prüfen"
],
	"\u0000More review actions\u0001": [
	"Weitere Prüfoptionen"
],
	"\u0000Check spelling permanently\u0001": [
	"Rechtschreibung dauerhaft prüfen"
],
	"\u0000Insert row\u0001": [
	"Zeile einfügen"
],
	"\u0000Delete selected rows\u0001": [
	"Gewählte Zeilen löschen"
],
	"\u0000Insert column\u0001": [
	"Spalte einfügen"
],
	"\u0000Delete selected columns\u0001": [
	"Gewählte Spalten löschen"
],
	"\u0000Cell fill color\u0001": [
	"Hintergrundfarbe der Zelle"
],
	"\u0000Cell border width\u0001": [
	"Rahmenstärke der Zelle"
],
	"\u0000Borders\u0001": [
	"Rahmen"
],
	"\u0000Off\u0001": [
	"Aus"
],
	"\u0000Turn automatic resizing of text frames off\u0001": [
	"Automatische Größenanpassung von Textrahmen ausschalten"
],
	"\u0000Shrink text\u0001": [
	"Text verkleinern"
],
	"\u0000Turn automatic shrink text on overflow on\u0001": [
	"\"Text bei Überlauf automatisch verkleinern\" ein- oder ausschalten"
],
	"\u0000Resize frame\u0001": [
	"Rahmengröße verändern"
],
	"\u0000Turn automatic height resizing of text frames on\u0001": [
	"Automatische Höhenanpassung von Textrahmen einschalten"
],
	"\u0000Options\u0001": [
	"Optionen"
],
	"\u0000More options\u0001": [
	"Weitere Optionen"
],
	"\u0000Autofit\u0001": [
	"AutoAnpassen"
],
	"\u0000Resize\u0001": [
	"Größe ändern"
],
	"\u0000Lock ratio\u0001": [
	"Seitenverhältnis sperren"
],
	"\u0000Lock or unlock the drawing aspect ratio\u0001": [
	"Seitenverhältnis der Zeichnung sperren bzw. entsperren"
],
	"\u0000Start local presentation\u0001": [
	"Lokale Präsentation starten"
],
	"\u0000View the presentation on your device.\u0001": [
	"Sehen Sie sich die Präsentation auf Ihrem Gerät an."
],
	"\u0000Start remote presentation\u0001": [
	"Online-Präsentation starten"
],
	"\u0000Broadcast your presentation over the Web.\u0001": [
	"Übertragen Sie Ihre Präsentation über das Web."
],
	"\u0000Close Presenter\u0001": [
	"Presenter schließen"
],
	"\u0000A general error occurred. Please try to reload the document. In case this does not help, please contact your system administrator.\u0001": [
	"Ein allgemeiner Fehler ist aufgetreten. Bitte versuchen Sie, das Dokument neu zu laden. Falls dies nicht hilft, kontaktieren Sie bitte Ihren Systemadministrator."
],
	"\u0000A general network error occurred. Please try to reload the document. In case this does not help, please contact your system administrator.\u0001": [
	"Ein allgemeiner Netzwerkfehler ist aufgetreten. Bitte versuchen Sie, das Dokument neu zu laden. Falls dies nicht hilft, kontaktieren Sie bitte Ihren Systemadministrator."
],
	"\u0000A general file storage error occurred. Please try to reload the document. In case this does not help, please contact your system administrator.\u0001": [
	"Ein allgemeiner Dateispeicherfehler ist aufgetreten. Bitte versuchen Sie, das Dokument neu zu laden. Falls dies nicht hilft, kontaktieren Sie bitte Ihren Systemadministrator."
],
	"\u0000The requested document does not exist.\u0001": [
	"Das angeforderte Dokument ist nicht vorhanden."
],
	"\u0000The presentation cannot be started. Please check the URL or contact the presenter.\u0001": [
	"Die Präsentation kann nicht gestartet werden. Bitte überprüfen Sie die URL oder kontaktieren Sie den Vortragenden."
],
	"\u0000This document does not have any content.\u0001": [
	"Dieses Dokument hat keinen Inhalt."
],
	"\u0000You do not have the appropriate permissions to read the document.\u0001": [
	"Sie haben nicht die entsprechenden Berechtigungen zum Lesen des Dokuments."
],
	"\u0000A general network error occurred. Please contact your system administrator.\u0001": [
	"Ein allgemeiner Netzwerkfehler ist aufgetreten. Bitte kontaktieren Sie Ihren Systemadministrator."
],
	"\u0000The maximum number of participants for this presentation has been reached. Joining is not possible.\u0001": [
	"Die maximale Teilnehmerzahl für diese Präsentation wurde erreicht. Eine Teilnahme ist nicht möglich."
],
	"\u0000The remote presentation cannot be started, because the document is currently being edited in collaboration. Please try again later.\u0001": [
	"Die Remote-Präsentation kann nicht gestartet werden, da das Dokument derzeit in Zusammenarbeit bearbeitet wird. Versuchen Sie es später erneut."
],
	"\u0000The remote presentation cannot be started, because a presentation is already being presented. Please try again later.\u0001": [
	"Die Remote-Präsentation kann nicht gestartet werden, da bereits eine Präsentation läuft. Versuchen Sie es später erneut."
],
	"\u0000A remote presentation cannot be started, because a needed service is not enabled. Please contact your system administrator.\u0001": [
	"Eine Remote-Präsentation kann nicht gestartet werden, da ein erforderlicher Dienst nicht aktiviert ist. Wenden Sie sich bitte an Ihren Systemadministrator."
],
	"\u0000Next slide\u0001": [
	"Nächste Folie"
],
	"\u0000Previous slide\u0001": [
	"Vorherige Folie"
],
	"\u0000Pause\u0001": [
	"Anhalten"
],
	"\u0000Pause presentation\u0001": [
	"Präsentation anhalten"
],
	"\u0000Pause the presentation\u0001": [
	"Die Präsentation anhalten"
],
	"\u0000Continue\u0001": [
	"Fortfahren"
],
	"\u0000Continue presentation\u0001": [
	"Präsentation fortführen"
],
	"\u0000Continue the presentation\u0001": [
	"Die Präsentation fortführen"
],
	"\u0000Toggle fullscreen\u0001": [
	"Vollbild an/aus"
],
	"\u0000Presenter navigation bar\u0001": [
	"Navigationsleiste Vortragender"
],
	"\u0000of %1$d\u0001": [
	"von %1$d"
],
	"\u0000Jump to slide\u0001": [
	"Wechseln zu Folie"
],
	"\u0000none\u0001": [
	"Keiner"
],
	"\u0000Participants\u0001": [
	"Teilnehmer"
],
	"\u0000Presenter\u0001": [
	"Vortragender"
],
	"\u0000View participants\u0001": [
	"Teilnehmer anzeigen"
],
	"\u0000Presentation start\u0001": [
	"Präsentationsbeginn"
],
	"\u0000%1$s has started the presentation.\u0001": [
	"%1$s hat die Präsentation gestartet."
],
	"\u0000Join Presentation\u0001": [
	"Präsentation beitreten"
],
	"\u0000Presentation end\u0001": [
	"Präsentationsende"
],
	"\u0000%1$s has ended the presentation.\u0001": [
	"%1$s hat die Präsentation beendet."
],
	"\u0000Presentation join\u0001": [
	"Präsentationsbeitritt"
],
	"\u0000Joining the presentation of %1$s.\u0001": [
	"Beitritt zur Präsentation von %1$s."
],
	"\u0000The limit of participants has been reached. Please contact the presenter %1$s.\u0001": [
	"Die maximale Anzahl von Teilnehmern wurde erreicht. Bitte kontaktieren Sie den Vortragenden %1$s."
],
	"\u0000The presentation document %1$s was deleted.\u0001": [
	"Das Präsentationsdokument %1$s wurde gelöscht."
],
	"\u0000The realtime connection is established.\u0001": [
	"Die Echtzeit-Verbindung ist aufgebaut."
],
	"\u0000The realtime connection is lost.\u0001": [
	"Die Echtzeit-Verbindung ist abgebrochen."
],
	"\u0000There are currently no participants.\u0001": [
	"Derzeit sind keine Teilnehmer vorhanden."
],
	"\u0000End of Slides\u0001": [
	"Folienende"
],
	"\u0000Presentation is paused.\u0001": [
	"Präsentation wurde angehalten."
],
	"\u0000Leave presentation\u0001": [
	"Präsentation verlassen"
],
	"\u0000Leave\u0001": [
	"Verlassen"
],
	"\u0000%1$d of %2$d\u0001": [
	"%1$d von %2$d"
],
	"\u0000%1$d %\u0001": [
	"%1$d %"
],
	"\u0000Start\u0001": [
	"Starten"
],
	"\u0000End\u0001": [
	"Ende"
],
	"\u0000End presentation\u0001": [
	"Präsentation beenden"
],
	"\u0000End the presentation\u0001": [
	"Die Präsentation beenden"
],
	"\u0000Join\u0001": [
	"Beitreten"
],
	"\u0000Join presentation\u0001": [
	"Präsentation beitreten"
],
	"\u0000Join the presentation\u0001": [
	"Der Präsentation beitreten"
],
	"\u0000Leave the presentation\u0001": [
	"Die Präsentation verlassen"
],
	"\u0000Save\u0001": [
	"Speichern"
],
	"\u0000Unsupported spell checker notification\u0001": [
	"Benachrichtigung über nicht unterstützte Rechtschreibprüfung"
],
	"\u0000Suppress missing spell checker warnings for the following languages:\u0001": [
	"Für die folgenden Sprachen Warnhinweise zu fehlender Rechtschreibprüfung unterdrücken:"
],
	"\u0000User dictionary\u0001": [
	"Benutzerwörterbuch"
],
	"\u0000Add a new word\u0001": [
	"Ein neues Wort hinzufügen"
],
	"\u0000Add\u0001": [
	"Hinzufügen"
],
	"\u0000Delete word\u0001": [
	"Wort löschen"
],
	"\u0000Documents\u0001": [
	"Dokumente"
],
	"\u0000Documents settings\u0001": [
	"Dokumenteneinstellungen"
],
	"\u0000Measurements\u0001": [
	"Maßeinheiten"
],
	"\u0000Show measurements in units of\u0001": [
	"Maßeinheiten anzeigen in Einheiten von"
],
	"\u0000Show measurements in units of inch, centimeter, or millimeter\u0001": [
	"Maßeinheiten anzeigen in Einheiten von Zoll, Zentimeter oder Millimeter"
],
	"\u0000centimeter\u0001": [
	"Zentimeter"
],
	"\u0000millimeter\u0001": [
	"Millimeter"
],
	"\u0000inch\u0001": [
	"Zoll"
],
	"\u0000Spell checking\u0001": [
	"Rechtschreibprüfung"
],
	"\u0000Check for errors permanently\u0001": [
	"Rechtschreibung dauerhaft prüfen"
],
	"\u0000Edit user dictionary\u0001": [
	"Benutzerwörterbuch bearbeiten"
],
	"\u0000Set language notification\u0001": [
	"Benachrichtigungen für Sprachen festlegen"
],
	"\u0000Theme\u0001": [
	"Theme"
],
	"\u0000Use %1$s theme in editors\u0001": [
	"%1$s-Theme in Editorfenstern verwenden"
],
	"\u0000My template folders\u0001": [
	"Meine Vorlagenordner"
],
	"\u0000Global template folders\u0001": [
	"Globale Vorlagenordner"
],
	"\u0000Select template folder\u0001": [
	"Vorlagenordner wählen"
],
	"\u0000Add new template folder\u0001": [
	"Neuen Vorlagenordner hinzufügen"
],
	"\u0000Permissions\u0001": [
	"Berechtigungen"
],
	"\u0000To grant users access to all templates in this folder, please use the Permission dialog. All users need to be able to read all objects in this folder.\u0001": [
	"Verwenden Sie bitte das Dialogfenster \"Berechtigungen\", um anderen Benutzern Zugriffsberechtigung auf alle Vorlagen in diesem Ordner zu erteilen. Alle Benutzer müssen in der Lage sein, alle Objekte in diesem Ordner zu lesen."
],
	"\u0000Data references are located on different sheets.\u0001": [
	"Datenreferenzen stammen aus unterschiedlichen Tabellenblättern."
],
	"\u0000Data references are too complex for this operation.\u0001": [
	"Datenreferenzen sind für diese Aktion zu komplex."
],
	"\u0000Select source data\u0001": [
	"Quelldaten wählen"
],
	"\u0000All comments on this sheet will be removed. Do you want to continue?\u0001": [
	"Alle Kommentare in diesem Tabellenblatt werden entfernt. Möchten Sie fortfahren?"
],
	"\u0000Delete notes\u0001": [
	"Notizen löschen"
],
	"\u0000All notes on this sheet will be removed. Do you want to continue?\u0001": [
	"Alle Notizen in diesem Tabellenblatt werden entfernt. Möchten Sie fortfahren?"
],
	"\u0000Delete sheet\u0001": [
	"Tabelle löschen"
],
	"\u0000Deleting a sheet cannot be undone. Proceed operation?\u0001": [
	"Das Löschen von Tabellenblättern kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?"
],
	"\u0000Copy sheet\u0001": [
	"Tabelle kopieren"
],
	"\u0000Rename sheet\u0001": [
	"Tabelle umbenennen"
],
	"\u0000Rename\u0001": [
	"Umbenennen"
],
	"\u0000Sorting\u0001": [
	"Sortierung"
],
	"\u0000Expand the selection?\u0001": [
	"Auswahl erweitern?"
],
	"funchelp\u0000argument%1$d\u0001": [
	"Argument%1$d"
],
	"funchelp-HYPGEOM.DIST\u0000cumulative\u0001": [
	"kumulativ"
],
	"funchelp-HYPGEOM.DIST\u0000If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function.\u0001": [
	"WAHR berechnet die kumulative Verteilungsfunktion. FALSCH berechnet die Wahrscheinlichkeit der Dichtefunktion."
],
	"funchelp-NEGBINOM.DIST\u0000cumulative\u0001": [
	"kumulativ"
],
	"funchelp-NEGBINOM.DIST\u0000If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function.\u0001": [
	"WAHR berechnet die kumulative Verteilungsfunktion. FALSCH berechnet die Wahrscheinlichkeit der Dichtefunktion."
],
	"funchelp-NORM.S.DIST\u0000cumulative\u0001": [
	"kumulativ"
],
	"funchelp-NORM.S.DIST\u0000If set to TRUE, calculates the cumulative distribution function; if set to FALSE, calculates the probability density function.\u0001": [
	"WAHR berechnet die kumulative Verteilungsfunktion. FALSCH berechnet die Wahrscheinlichkeit der Dichtefunktion."
],
	"funchelp-NUMBERVALUE\u0000group_separator\u0001": [
	"Gruppentrennzeichen"
],
	"funchelp-NUMBERVALUE\u0000Defines the character used to separate groups of numbers (e.g. thousands, millions).\u0001": [
	"Definiert das Zeichen zum Trennen von Zifferngruppen (z.B. Tausender, Millionen)"
],
	"funchelp-PERCENTRANK.INC\u0000significance\u0001": [
	"Signifikanz"
],
	"funchelp-PERCENTRANK.INC\u0000The number of significant digits to round the returned value to.\u0001": [
	"Anzahl der gültigen Stellen, auf die der zurückgegebene Wert gerundet werden soll."
],
	"\u0000Sheet%1$d\u0001": [
	"Tabelle%1$d"
],
	"filter\u0000Table\u0001": [
	"Tabelle"
],
	"filter\u0000Column\u0001": [
	"Spalte"
],
	"\u0000Sheet \"%1$s\" activated.\u0001": [
	"Tabelle \"%1$s\" aktiviert."
],
	"\u0000%1$d drawing object selected.\u0001%1$d drawing objects selected.": [
	"%1$d Zeichnungsobjekt ausgewählt.",
	"%1$d Zeichnungsobjekte ausgewählt."
],
	"\u0000%1$d cell range selected.\u0001%1$d cell ranges selected.": [
	"%1$d Zellbereich ausgewählt.",
	"%1$d Zellbereiche ausgewählt."
],
	"\u0000Columns %1$s to %2$s selected.\u0001": [
	"Spalten %1$s bis %2$s ausgewählt."
],
	"\u0000Rows %1$s to %2$s selected.\u0001": [
	"Zeilen %1$s bis %2$s ausgewählt."
],
	"\u0000%1$s to %2$s selected.\u0001": [
	"%1$s bis %2$s ausgewählt."
],
	"\u0000It is not possible to create a chart out of more than 50 input cells.\u0001": [
	"Aus mehr als 50 Eingabezellen kann kein Diagramm erstellt werden."
],
	"\u0000Scroll to the previous sheet\u0001": [
	"Zum vorherigen Datenblatt zurückscrollen"
],
	"\u0000Scroll to the next sheet\u0001": [
	"Zum nächsten Datenblatt weiterscrollen"
],
	"\u0000Select sheet\u0001": [
	"Tabellenblatt wählen"
],
	"\u0000Horizontal alignment\u0001": [
	"Horizontale Ausrichtung"
],
	"\u0000Vertical alignment\u0001": [
	"Vertikale Ausrichtung"
],
	"\u0000Cell style\u0001": [
	"Zellenstil"
],
	"number-format\u0000%1$s (%2$s)\u0001": [
	"%1$s (%2$s)"
],
	"number-format\u0000%1$s (%2$s, hidden symbol)\u0001": [
	"%1$s (%2$s, ausgeblendetes Symbol)"
],
	"number-format\u0000Leave empty space for currency symbol\u0001": [
	"Leerzeichen für Währungssymbol lassen"
],
	"number-format\u0000%1$s (%2$s, %3$s)\u0001": [
	"%1$s (%2$s, %3$s)"
],
	"filter\u0000Blank cells\u0001": [
	"Leere Zellen"
],
	"\u0000Number formats\u0001": [
	"Zahlenformate"
],
	"\u0000Number format\u0001": [
	"Zahlenformat"
],
	"number-format\u0000More number formats\u0001": [
	"Weitere Zahlenformate"
],
	"\u0000Merge or unmerge cells\u0001": [
	"Zellen verbinden oder trennen"
],
	"\u0000Merge cells\u0001": [
	"Zellen verbinden"
],
	"\u0000Merge cells horizontally\u0001": [
	"Zellen horizontal verbinden"
],
	"\u0000Merge cells vertically\u0001": [
	"Zellen vertikal verbinden"
],
	"\u0000Unmerge cells\u0001": [
	"Zellen trennen"
],
	"named ranges\u0000Named ranges\u0001": [
	"Benannte Bereiche"
],
	"named ranges\u0000Show or hide the named ranges in this document\u0001": [
	"Benannte Bereiche in diesem Dokument ein- oder ausblenden"
],
	"named ranges\u0000Add new range\u0001": [
	"Neuen Bereich eingeben"
],
	"named ranges\u0000Add a named range\u0001": [
	"Benannten Bereich hinzufügen"
],
	"sort\u0000Sorting\u0001": [
	"Sortieren"
],
	"\u0000Type of the subtotal value\u0001": [
	"Art des Teilergebnisses"
],
	"\u0000Sum: %1$s\u0001": [
	"Summe: %1$s"
],
	"\u0000Sum of selected cells\u0001": [
	"Summe der gewählten Zellen"
],
	"\u0000Min: %1$s\u0001": [
	"Min.: %1$s"
],
	"\u0000Minimum value in selection\u0001": [
	"Minimaler Wert in Auswahl"
],
	"\u0000Max: %1$s\u0001": [
	"Max.: %1$s"
],
	"\u0000Maximum value in selection\u0001": [
	"Maximaler Wert in Auswahl"
],
	"\u0000Count: %1$s\u0001": [
	"Anzahl: %1$s"
],
	"\u0000Number of selected cells that contain data\u0001": [
	"Anzahl gewählter Zellen, die Daten enthalten"
],
	"\u0000Numerical count: %1$s\u0001": [
	"Numerische Anzahl: %1$s"
],
	"\u0000Number of selected cells that contain numerical data\u0001": [
	"Anzahl gewählter Zellen mit numerischen Daten"
],
	"\u0000Average: %1$s\u0001": [
	"Durchschnitt: %1$s"
],
	"\u0000Average of selected cells\u0001": [
	"Durchschnitt der gewählten Zellen"
],
	"\u0000Delete row\u0001": [
	"Zeile löschen"
],
	"\u0000Delete column\u0001": [
	"Spalte löschen"
],
	"\u0000Insert rows\u0001": [
	"Zeilen einfügen"
],
	"\u0000Insert columns\u0001": [
	"Spalten einfügen"
],
	"\u0000Column width\u0001": [
	"Spaltenbreite"
],
	"\u0000Row height\u0001": [
	"Zeilenhöhe"
],
	"borders\u0000Double line\u0001": [
	"Doppelte Linie"
],
	"borders\u0000Single\u0001": [
	"Einfach"
],
	"borders\u0000Double\u0001": [
	"Doppelt"
],
	"borders\u0000Dotted\u0001": [
	"Gepunktet"
],
	"borders\u0000Dashed\u0001": [
	"Gestrichelt"
],
	"\u0000Cell protection\u0001": [
	"Zellschutz"
],
	"\u0000Change cell protection for the selected cells\u0001": [
	"Zellschutz für die ausgewählten Zellen ändern"
],
	"\u0000Unlock cell\u0001": [
	"Zelle entsperren"
],
	"\u0000Unlock the cell in protected sheets\u0001": [
	"Zelle in geschützten Tabellen entsperren"
],
	"\u0000Lock cell\u0001": [
	"Zelle sperren"
],
	"\u0000Lock the cell in protected sheets\u0001": [
	"Zelle in geschützten Tabellen sperren"
],
	"\u0000Unhide formula\u0001": [
	"Formel einblenden"
],
	"\u0000Unhide the formula in protected sheets\u0001": [
	"Formel in geschützten Tabellen einblenden"
],
	"\u0000Hide formula\u0001": [
	"Formel ausblenden"
],
	"\u0000Hide the formula in protected sheets\u0001": [
	"Formel in geschützten Tabellen ausblenden"
],
	"\u0000Note\u0001": [
	"Notiz"
],
	"\u0000Note-Handling\u0001": [
	"Notizverarbeitung"
],
	"\u0000Comment-Handling\u0001": [
	"Kommentarverarbeitung"
],
	"\u0000Toggle visibility of selected note\u0001": [
	"Sichtbarkeit der ausgewählten Notiz an/aus"
],
	"\u0000Toggle visibility of selected comment\u0001": [
	"Sichtbarkeit des ausgewählten Kommentars an/aus"
],
	"\u0000Delete selected note\u0001": [
	"Ausgewählte Notiz löschen"
],
	"\u0000Delete selected comment\u0001": [
	"Ausgewählten Kommentar löschen"
],
	"\u0000Show/Hide\u0001": [
	"Einblenden/Ausblenden"
],
	"sheet-split\u0000Split sheet\u0001": [
	"Tabelle teilen"
],
	"sheet-split\u0000Split the sheet above and left of the current cursor position\u0001": [
	"Tabelle oberhalb und links vom Cursor teilen"
],
	"sheet-split\u0000Freeze sheet\u0001": [
	"Tabelle fixieren"
],
	"sheet-split\u0000Freeze the rows above and the columns left of the cursor\u0001": [
	"Zeilen oberhalb und Spalten links vom Cursor fixieren"
],
	"\u0000Freeze first row\u0001": [
	"Erste Zeile fixieren"
],
	"\u0000Freeze the first visible row\u0001": [
	"Erste sichtbare Zeile fixieren"
],
	"\u0000Freeze first column\u0001": [
	"Erste Spalte fixieren"
],
	"\u0000Freeze the first visible column\u0001": [
	"Erste sichtbare Spalte fixieren"
],
	"\u0000Freeze first row and column\u0001": [
	"Erste Zeile und Spalte fixieren"
],
	"\u0000Freeze the first visible row and the first visible column\u0001": [
	"Erste sichtbare Zeile und erste sichtbare Spalte fixieren"
],
	"\u0000Sum\u0001": [
	"Summe"
],
	"\u0000Sum automatically\u0001": [
	"Automatisch berechnen"
],
	"\u0000Function\u0001": [
	"Funktion"
],
	"\u0000Insert function at cursor location\u0001": [
	"Funktion an der Cursor-Position einfügen"
],
	"filter\u0000Filter\u0001": [
	"Filter"
],
	"\u0000Filter the selected cells\u0001": [
	"Markierte Zellen filtern"
],
	"filter\u0000Reapply\u0001": [
	"Erneut anwenden"
],
	"\u0000Reapply the filter in the selected cells\u0001": [
	"Filter auf die markierten Zellen erneut anwenden"
],
	"\u0000No Style, No Grid\u0001": [
	"Kein Stil, kein Raster"
],
	"number-format\u0000Custom currency format\u0001": [
	"Benutzerdefiniertes Währungsformat"
],
	"number-format\u0000Currency symbol\u0001": [
	"Währungssymbol"
],
	"number-format\u0000Decimal digits\u0001": [
	"Dezimalziffern"
],
	"number-format\u0000Use thousands separator\u0001": [
	"Tausendertrennzeichen verwenden"
],
	"number-format\u0000Use accounting format\u0001": [
	"Buchhaltungsformat verwenden"
],
	"number-format\u0000Use ISO currency code\u0001": [
	"ISO-Währungscode verwenden"
],
	"number-format\u0000Red text color for negative numbers\u0001": [
	"Rote Textfarbe für negative Zahlen"
],
	"\u0000Preview\u0001": [
	"Vorschau"
],
	"number-format\u0000Positive\u0001": [
	"Positiv"
],
	"number-format\u0000Negative\u0001": [
	"Negativ"
],
	"number-format\u0000Zero\u0001": [
	"Null"
],
	"sort\u0000All sort criteria must have a column or row specified.\u0001": [
	"Für alle Sortierkriterien muss eine Spalte oder Zeile angegeben sein."
],
	"sort\u0000Some columns or rows are being sorted more than once.\u0001": [
	"Einige Spalten oder Zeilen sind mehr als einmal sortiert."
],
	"sort\u0000Options\u0001": [
	"Optionen"
],
	"sort\u0000Selection has headers\u0001": [
	"Auswahl enthält Überschriften"
],
	"sort\u0000Add sort criteria\u0001": [
	"Sortierkriterien hinzufügen"
],
	"sort\u0000Direction\u0001": [
	"Reihenfolge"
],
	"sort\u0000Sort by\u0001": [
	"Sortieren nach"
],
	"sort\u0000Order\u0001": [
	"Reihenfolge"
],
	"sort\u0000undefined\u0001": [
	"Nicht festgelegt"
],
	"sort\u0000Top to bottom\u0001": [
	"Von oben nach unten"
],
	"sort\u0000Left to right\u0001": [
	"Von links nach rechts"
],
	"sort\u0000Custom sort\u0001": [
	"Benutzerdefinierte Sortierung"
],
	"\u0000Sort\u0001": [
	"Sortieren"
],
	"\u0000Change name\u0001": [
	"Namen ändern"
],
	"\u0000Insert name\u0001": [
	"Namen einfügen"
],
	"\u0000Change\u0001": [
	"Ändern"
],
	"\u0000Enter name\u0001": [
	"Namen eingeben"
],
	"\u0000Name\u0001": [
	"Name"
],
	"\u0000Enter formula\u0001": [
	"Formel eingeben"
],
	"\u0000Formula\u0001": [
	"Formel"
],
	"function-dialog\u0000Pick a category\u0001": [
	"Eine Kategorie wählen"
],
	"function-dialog\u0000All\u0001": [
	"Alle"
],
	"function-dialog\u0000Pick a function\u0001": [
	"Funktion wählen"
],
	"function-dialog\u0000Syntax\u0001": [
	"Syntax"
],
	"function-dialog\u0000Parameters\u0001": [
	"Parameter"
],
	"function-dialog\u0000%1$s (optional)\u0001": [
	"%1$s (optional)"
],
	"function-dialog\u0000Insert function\u0001": [
	"Funktion einfügen"
],
	"function-dialog\u0000Insert\u0001": [
	"Einfügen"
],
	"\u0000Reorder sheets\u0001": [
	"Tabellen neu sortieren"
],
	"\u0000Move to top\u0001": [
	"Ganz nach oben"
],
	"\u0000Move up\u0001": [
	"Nach oben"
],
	"\u0000Move down\u0001": [
	"Nach unten"
],
	"\u0000Move to bottom\u0001": [
	"Ganz nach unten"
],
	"\u0000Enter sheet name\u0001": [
	"Tabellennamen eingeben"
],
	"\u0000Unhide sheets\u0001": [
	"Tabellenblätter einblenden"
],
	"\u0000Table ranges\u0001": [
	"Tabellenbereiche"
],
	"\u0000Functions\u0001": [
	"Funktionen"
],
	"\u0000Insert mode\u0001": [
	"Einfügemodus"
],
	"\u0000Edit mode\u0001": [
	"Bearbeitungsmodus"
],
	"menu-title\u0000Rows/Columns\u0001": [
	"Zeilen/Spalten"
],
	"menu-title\u0000Cells\u0001": [
	"Zellen"
],
	"menu-title\u0000Data\u0001": [
	"Daten"
],
	"menu-title\u0000Filter\u0001": [
	"Filtern"
],
	"menu-title\u0000Sort\u0001": [
	"Sortieren"
],
	"\u0000Insert sheet\u0001": [
	"Tabelle einfügen"
],
	"\u0000Unprotect sheet\u0001": [
	"Tabellenschutz aufheben"
],
	"\u0000Protect sheet\u0001": [
	"Tabelle schützen"
],
	"\u0000Show sheet\u0001": [
	"Tabelle einblenden"
],
	"\u0000Hide sheet\u0001": [
	"Tabelle ausblenden"
],
	"\u0000Automatic word wrap\u0001": [
	"Automatischer Textumbruch"
],
	"\u0000Delete decimal place\u0001": [
	"Dezimalstelle löschen"
],
	"\u0000Add decimal place\u0001": [
	"Dezimalstelle hinzufügen"
],
	"function-category\u0000Complex numbers\u0001": [
	"Komplexe Zahlen"
],
	"function-category\u0000Conversion\u0001": [
	"Umwandeln"
],
	"function-category\u0000Database\u0001": [
	"Datenbank"
],
	"function-category\u0000Date and time\u0001": [
	"Datum und Uhrzeit"
],
	"function-category\u0000Engineering\u0001": [
	"Technisch"
],
	"function-category\u0000Financial\u0001": [
	"Finanzmathematik"
],
	"function-category\u0000Information\u0001": [
	"Informationen"
],
	"function-category\u0000Logical\u0001": [
	"Logisch"
],
	"function-category\u0000Mathematical\u0001": [
	"Mathematisch"
],
	"function-category\u0000Matrix\u0001": [
	"Matrix"
],
	"function-category\u0000Reference\u0001": [
	"Bezug"
],
	"function-category\u0000Statistical\u0001": [
	"Statistisch"
],
	"function-category\u0000Text\u0001": [
	"Text"
],
	"function-category\u0000Web\u0001": [
	"Internet"
],
	"number-format\u0000Custom ...\u0001": [
	"Benutzerdefiniert ..."
],
	"number-format\u0000Currency ...\u0001": [
	"Währung ..."
],
	"sort\u0000Ascending\u0001": [
	"Aufsteigend"
],
	"sort\u0000Sort from smallest to largest value\u0001": [
	"Vom kleinsten zum größten Wert sortieren"
],
	"sort\u0000Descending\u0001": [
	"Absteigend"
],
	"sort\u0000Sort from largest to smallest value\u0001": [
	"Vom größten zum kleinsten Wert sortieren"
],
	"sort\u0000Custom\u0001": [
	"Benutzerdefiniert"
],
	"sort\u0000Settings for sorting\u0001": [
	"Sortiereinstellungen"
],
	"\u0000Clear contents\u0001": [
	"Inhalte löschen"
],
	"number-format\u0000General\u0001": [
	"Allgemein"
],
	"number-format\u0000Number\u0001": [
	"Zahl"
],
	"number-format\u0000Currency\u0001": [
	"Währung"
],
	"number-format\u0000Accounting\u0001": [
	"Buchhaltung"
],
	"number-format\u0000Date\u0001": [
	"Datum"
],
	"number-format\u0000Time\u0001": [
	"Uhrzeit"
],
	"number-format\u0000Date and time\u0001": [
	"Datum und Uhrzeit"
],
	"number-format\u0000Percentage\u0001": [
	"Prozent"
],
	"number-format\u0000Scientific\u0001": [
	"Exponentialzahl"
],
	"number-format\u0000Fraction\u0001": [
	"Bruch"
],
	"number-format\u0000Text\u0001": [
	"Text"
],
	"number-format\u0000Custom\u0001": [
	"Benutzerdefiniert"
],
	"\u0000Calculating\u0001": [
	"Berechnung ..."
],
	"\u0000Column %1$s\u0001": [
	"Spalte %1$s"
],
	"\u0000Row %1$s\u0001": [
	"Zeile %1$s"
],
	"\u0000Cell %1$s\u0001": [
	"Zelle %1$s"
],
	"\u0000Series %1$d\u0001": [
	"Serie %1$d"
],
	"\u0000The sheet name must not be empty. Please enter a name.\u0001": [
	"Der Tabellenname darf nicht leer sein. Bitte geben Sie einen Namen ein."
],
	"\u0000This sheet name contains invalid characters. Please ensure that the name does not contain / \\ * ? : [ or ], and does neither start nor end with an apostrophe.\u0001": [
	"Dieser Tabellenname enthält ungültige Zeichen. Bitte stellen Sie sicher, dass der Name nicht die folgenden Zeichen enthält: / \\ * ? : [ oder ] und dass er nicht mit einem Apostroph beginnt oder endet."
],
	"\u0000This sheet name is already used. Please enter another name.\u0001": [
	"Eine Tabelle mit diesem Namen ist bereits vorhanden. Bitte geben Sie einen anderen Namen ein."
],
	"\u0000You cannot use this command on a protected sheet.\u0001": [
	"Dieser Befehl kann nicht auf eine geschützte Tabelle angewendet werden."
],
	"\u0000Please select only entire columns, or just some cells in the sheet.\u0001": [
	"Bitte wählen Sie nur ganze Spalten oder nur einige Zellen im Tabellenblatt aus."
],
	"\u0000It is not possible to modify more than %1$d columns at the same time.\u0001": [
	"Es können nicht mehr als %1$d Spalten gleichzeitig geändert werden."
],
	"\u0000Please select only entire rows, or just some cells in the sheet.\u0001": [
	"Bitte wählen Sie nur ganze Zeilen oder nur einige Zellen im Tabellenblatt aus."
],
	"\u0000It is not possible to modify more than %1$d rows at the same time.\u0001": [
	"Es können nicht mehr als %1$d Zeilen gleichzeitig geändert werden."
],
	"\u0000Protected cells cannot be modified.\u0001": [
	"Geschützte Zellen können nicht geändert werden."
],
	"\u0000It is not possible to modify more than %1$d cells at the same time.\u0001": [
	"Es können nicht mehr als %1$d Zellen gleichzeitig geändert werden."
],
	"\u0000It is not possible to insert new cells because non-empty cells would be pushed off the end of the sheet.\u0001": [
	"Es können keine neuen Zellen eingefügt werden, da Zellen mit Inhalt über das Tabellenblatt hinausgeschoben würden."
],
	"\u0000Overlapping ranges cannot be merged.\u0001": [
	"Überlappende Bereiche können nicht verbunden werden."
],
	"\u0000It is not possible to merge more than %1$d ranges at the same time.\u0001": [
	"Es können nicht mehr als %1$d Zellen gleichzeitig verbunden werden."
],
	"\u0000Autofill over merged cells is not allowed.\u0001": [
	"AutoAusfüllen über verbundene Zellen ist nicht zulässig."
],
	"\u0000This name contains invalid characters. Please enter another name.\u0001": [
	"Dieser Name enthält ungültige Zeichen. Bitte geben Sie einen anderen Namen ein."
],
	"\u0000A cell address cannot be used as name. Please enter another name.\u0001": [
	"Eine Zelladresse kann nicht als Name verwendet werden. Bitte geben Sie einen anderen Namen ein."
],
	"\u0000This name is already used. Please enter another name.\u0001": [
	"Dieser Name wird bereits verwendet. Bitte geben Sie einen anderen Namen ein."
],
	"\u0000Table cannot be created on multiple cell ranges.\u0001": [
	"Tabellen können nicht aus mehreren Zellbereichen erstellt werden."
],
	"\u0000Table cannot be created on another filtered range.\u0001": [
	"Tabellen können nicht aus einem anderen gefilterten Zellbereich erstellt werden."
],
	"\u0000Parts of a table cannot be moved.\u0001": [
	"Teile einer Tabelle können nicht verschoben werden."
],
	"\u0000Parts of a table cannot be changed.\u0001": [
	"Teile einer Tabelle können nicht geändert werden."
],
	"\u0000The header cells of a table cannot be changed.\u0001": [
	"Kopfzellen einer Tabelle können nicht geändert werden."
],
	"\u0000Filter cannot be applied to multiple cell ranges.\u0001": [
	"Der Filter kann nicht auf mehrere Zellbereiche angewendet werden."
],
	"\u0000Filter cannot be applied to another filtered range.\u0001": [
	"Der Filter kann nicht auf bereits gefilterte Zellbereiche angewendet werden."
],
	"\u0000Filtering cannot be performed on blank cells.\u0001": [
	"Filtern kann nicht auf leere Zellen angewendet werden."
],
	"\u0000Parts of the filter cannot be moved.\u0001": [
	"Teile des Filters können nicht verschoben werden."
],
	"\u0000Sorting cannot be performed on multiple cell ranges.\u0001": [
	"Sortieren kann nicht auf mehrere Zellbereiche angewendet werden."
],
	"\u0000Sorting cannot be performed on blank cells.\u0001": [
	"Sortieren kann nicht auf leere Zellen angewendet werden."
],
	"\u0000Sorting cannot be performed on more than %1$d columns or rows.\u0001": [
	"Sortieren kann nicht auf mehr als %1$d Spalten oder Zeilen angewendet werden."
],
	"\u0000Sorting over merged cells is not allowed.\u0001": [
	"Sortieren über zusammengeführte Bereiche ist nicht zulässig."
],
	"\u0000No results for your search.\u0001": [
	"Ihre Suche ergab keine Treffer."
],
	"\u0000No more results for your search.\u0001": [
	"Es wurden keine weiteren Ergebnisse für Ihre Suche gefunden."
],
	"\u0000Nothing to replace.\u0001": [
	"Nichts zu ersetzen."
],
	"\u0000The formula contains an error.\u0001": [
	"Die Formel enthält einen Fehler."
],
	"\u0000Parts of a matrix formula cannot be changed.\u0001": [
	"Teile einer Matrixformel können nicht geändert werden."
],
	"\u0000It is not possible to insert cells into a matrix formula.\u0001": [
	"Zellen können nicht in eine Matrixformel eingefügt werden."
],
	"\u0000Parts of a matrix formula cannot be deleted.\u0001": [
	"Teile einer Matrixformel können nicht gelöscht werden."
],
	"\u0000It is not possible to insert a matrix formula with more than %1$d elements.\u0001": [
	"Es ist nicht möglich, eine Matrix-Formel mit mehr als %1$d Elementen einzufügen."
],
	"\u0000It is not possible to insert a matrix formula over merged cells.\u0001": [
	"Matrixformeln können nicht in verbundene Zellen eingegeben werden."
],
	"\u0000No source data available for the drop-down list.\u0001": [
	"Es stehen keine Quelldaten für das Ausklappmenü zur Verfügung."
],
	"\u0000It is not possible to copy more than %1$d cells at the same time.\u0001": [
	"Es können nicht mehr als %1$d Zellen gleichzeitig kopiert werden."
],
	"\u0000It is not possible to paste more than %1$d cells at the same time.\u0001": [
	"Es können nicht mehr als %1$d Zellen gleichzeitig eingefügt werden."
],
	"\u0000It is not possible to paste outside of the valid sheet area.\u0001": [
	"Es ist nicht möglich, außerhalb des gültigen Tabellenbereichs einzufügen."
],
	"\u0000Pasting into protected cells is not allowed.\u0001": [
	"Das Einfügen in geschützte Zellen ist nicht zulässig."
],
	"\u0000You cannot paste this here because the copy area and paste area are not the same size. Select just one cell in the paste area or an area with the same size, and try pasting again.\u0001": [
	"Sie können dies hier nicht einfügen, da der Kopierbereich und Einfügebereich nicht die gleiche Größe haben. Wählen Sie nur eine Zelle im Einfügebereich oder einen Bereich mit der gleichen Größe und versuchen Sie es erneut."
],
	"\u0000File type not supported.\u0001": [
	"Dateityp wird nicht unterstützt."
],
	"\u0000Objects cannot be inserted into a protected sheet.\u0001": [
	"In geschützte Tabellenblätter können keine Objekte eingefügt werden."
],
	"\u0000Objects on a protected sheet cannot be deleted.\u0001": [
	"Objekte in einer geschützten Tabelle können nicht gelöscht werden."
],
	"\u0000Objects on a protected sheet cannot be changed.\u0001": [
	"Objekte auf einem geschützten Tabellenblatt können nicht geändert werden."
],
	"\u0000Notes cannot be inserted into a protected sheet.\u0001": [
	"In geschützte Tabellenblätter können keine Notizen eingefügt werden."
],
	"\u0000Comments cannot be inserted into a protected sheet.\u0001": [
	"In geschützte Tabellenblätter können keine Kommentare eingefügt werden."
],
	"\u0000Notes on a protected sheet cannot be deleted.\u0001": [
	"Notizen in einem geschützten Tabellenblatt können nicht gelöscht werden."
],
	"\u0000Comments on a protected sheet cannot be deleted.\u0001": [
	"Kommentare in einem geschützten Tabellenblatt können nicht gelöscht werden."
],
	"\u0000Notes on a protected sheet cannot be changed.\u0001": [
	"Notizen in einem geschützten Tabellenblatt können nicht geändert werden."
],
	"\u0000Comments on a protected sheet cannot be changed.\u0001": [
	"Kommentare in einem geschützten Tabellenblatt können nicht geändert werden."
],
	"\u0000No more notes found.\u0001": [
	"Es wurden keine weiteren Notizen gefunden."
],
	"\u0000No more comments found.\u0001": [
	"Es wurden keine weiteren Kommentare gefunden."
],
	"\u0000The search continues from the beginning of this document.\u0001": [
	"Die Suche wird am Anfang dieses Dokuments fortgesetzt."
],
	"\u0000Collapse formula bar\u0001": [
	"Formelleiste einklappen"
],
	"\u0000Expand formula bar\u0001": [
	"Formelleiste ausklappen"
],
	"\u0000Drag to change column width\u0001": [
	"Zum Ändern der Spaltenbreite ziehen"
],
	"\u0000Drag to show hidden column\u0001": [
	"Zum Anzeigen ausgeblendeter Spalten ziehen"
],
	"\u0000Drag to change row height\u0001": [
	"Zum Ändern der Zeilenhöhe ziehen"
],
	"\u0000Drag to show hidden row\u0001": [
	"Zum Anzeigen ausgeblendeter Zeilen ziehen"
],
	"\u0000More sheet operations\u0001": [
	"Weitere Tabellenaktionen"
],
	"\u0000Rows\u0001": [
	"Zeilen"
],
	"\u0000Row\u0001": [
	"Zeile"
],
	"\u0000Columns\u0001": [
	"Spalten"
],
	"\u0000Column\u0001": [
	"Spalte"
],
	"\u0000Named range\u0001": [
	"Benannter Bereich"
],
	"comment-actions\u0000Comment\u0001": [
	"Kommentar"
],
	"\u0000Unfreeze sheet\u0001": [
	"Fixierung des Tabellenblatts aufheben"
],
	"\u0000Freeze sheet\u0001": [
	"Tabelle fixieren"
],
	"\u0000Set optimal column width\u0001": [
	"Optimale Spaltenbreite einstellen"
],
	"\u0000Hide columns\u0001": [
	"Spalten ausblenden"
],
	"\u0000Hide column\u0001": [
	"Spalte ausblenden"
],
	"\u0000Show hidden columns\u0001": [
	"Ausgeblendete Spalten anzeigen"
],
	"\u0000Set optimal row height\u0001": [
	"Optimale Zeilenhöhe festlegen"
],
	"\u0000Hide rows\u0001": [
	"Zeilen ausblenden"
],
	"\u0000Hide row\u0001": [
	"Zeile ausblenden"
],
	"\u0000Show hidden rows\u0001": [
	"Ausgeblendete Zeilen anzeigen"
],
	"\u0000Delete name\u0001": [
	"Namen löschen"
],
	"named ranges\u0000Add new named range\u0001": [
	"Neuen benannten Bereich hinzufügen"
],
	"named ranges\u0000No named ranges defined.\u0001": [
	"Es wurden keine benannten Bereiche definiert."
],
	"filter\u0000Select values for filtering or sorting\u0001": [
	"Werte zum Filtern oder Sortieren wählen"
],
	"\u0000Select a value for this cell\u0001": [
	"Wählen Sie einen Wert für diese Zelle"
],
	"\u0000Circular Reference\u0001": [
	"Zirkelbezug"
],
	"\u0000A reference in the formula is dependent on the result of the formula cell.\u0001": [
	"Eine Referenz in der Formel hängt vom Ergebnis der Formelzelle ab."
],
	"\u0000This document exceeds the spreadsheet size and complexity limits. Calculation has been stopped. Formula results are not updated anymore.\u0001": [
	"Dieses Dokument überschreitet die maximale Größe und Komplexität für Tabellen. Die Berechnung wurde gestoppt. Formelergebnisse werden nicht mehr aktualisiert."
],
	"\u0000This spreadsheet contains formulas with unsupported functions:\u0001": [
	"Dieses Tabellenblatt enthält Formeln mit nicht unterstützten Funktionen:"
],
	"\u0000There are no comments on this sheet.\u0001": [
	"Dieses Tabellenblatt enthält keine Kommentare."
],
	"sheet-split\u0000Split and freeze\u0001": [
	"Teilen und fixieren"
],
	"\u0000Show formula bar\u0001": [
	"Formelleiste anzeigen"
],
	"\u0000Show or hide the formula bar\u0001": [
	"Formelleiste ein- oder ausblenden"
],
	"\u0000Show grid lines\u0001": [
	"Gitternetzlinien anzeigen"
],
	"\u0000Show or hide the cell grid lines in the current sheet\u0001": [
	"Zellen-Gitternetzlinien in aktueller Tabelle ein- oder ausblenden"
],
	"\u0000Show sheet tabs\u0001": [
	"Blattregisterkarten anzeigen"
],
	"\u0000Show or hide the sheet tabs below the sheet area\u0001": [
	"Blattregisterkarten unterhalb des Tabellenbereichs ein- oder ausblenden"
],
	"chart-source\u0000Data source\u0001": [
	"Datenquelle"
],
	"chart-source\u0000Edit data references\u0001": [
	"Datenreferenzen bearbeiten"
],
	"chart-source\u0000Switch rows and columns\u0001": [
	"Zeilen und Spalten tauschen"
],
	"chart-source\u0000First row as label\u0001": [
	"Erste Zeile als Beschriftung"
],
	"chart-source\u0000First column as label\u0001": [
	"Erste Spalte als Beschriftung"
],
	"note-actions\u0000Previous\u0001": [
	"Zurück"
],
	"note-actions\u0000Go to previous note\u0001": [
	"Zur vorherigen Notiz"
],
	"note-actions\u0000Next\u0001": [
	"Weiter"
],
	"note-actions\u0000Go to next note\u0001": [
	"Zur nächsten Notiz"
],
	"note-actions\u0000Show/Hide\u0001": [
	"Einblenden/Ausblenden"
],
	"note-actions\u0000Show/Hide selected note\u0001": [
	"Ausgewählte Notiz einblenden/ausblenden"
],
	"comment-actions\u0000Show/Hide\u0001": [
	"Einblenden/Ausblenden"
],
	"comment-actions\u0000Show/Hide selected comment\u0001": [
	"Ausgewählten Kommentar einblenden/ausblenden"
],
	"note-actions\u0000Delete\u0001": [
	"Löschen"
],
	"note-actions\u0000Delete note\u0001": [
	"Notiz löschen"
],
	"comment-actions\u0000Delete comment\u0001": [
	"Kommentar löschen"
],
	"note-actions\u0000Show all\u0001": [
	"Alle anzeigen"
],
	"note-actions\u0000Show all notes\u0001": [
	"Alle Notizen anzeigen"
],
	"comment-actions\u0000Show all\u0001": [
	"Alle anzeigen"
],
	"comment-actions\u0000Show all comments\u0001": [
	"Alle Kommentare anzeigen"
],
	"note-actions\u0000Hide all\u0001": [
	"Alle ausblenden"
],
	"note-actions\u0000Hide all notes\u0001": [
	"Alle Notizen ausblenden"
],
	"comment-actions\u0000Hide all\u0001": [
	"Alle ausblenden"
],
	"comment-actions\u0000Hide all comments\u0001": [
	"Alle Kommentare ausblenden"
],
	"note-actions\u0000Delete all\u0001": [
	"Alle löschen"
],
	"note-actions\u0000Delete all notes\u0001": [
	"Alle Notizen löschen"
],
	"comment-actions\u0000Delete all comments\u0001": [
	"Alle Kommentare löschen"
],
	"\u0000Notes\u0001": [
	"Notizen"
],
	"comment-actions\u0000Insert comment\u0001": [
	"Kommentar einfügen"
],
	"\u0000Document images could not be processed. Send as mail is not possible.\u0001": [
	"Dokumentbilder konnten nicht verarbeitet werden. Senden per E-Mail ist nicht möglich."
],
	"\u0000Auto\u0001": [
	"Auto"
],
	"\u0000English\u0001": [
	"Englisch"
],
	"\u0000Dutch\u0001": [
	"Niederländisch"
],
	"\u0000French\u0001": [
	"Französisch"
],
	"\u0000German\u0001": [
	"Deutsch"
],
	"\u0000Italian\u0001": [
	"Italienisch"
],
	"\u0000Portuguese\u0001": [
	"Portugiesisch"
],
	"\u0000Spanish\u0001": [
	"Spanisch"
],
	"\u0000Inappropriate content detected. Please try again with different input.\u0001": [
	"Unangemessener Inhalt entdeckt. Bitte versuchen Sie es noch einmal mit einer anderen Eingabe."
],
	"\u0000API request failed. The service might be unavailable. Please try again in a few minutes.\u0001": [
	"API-Anfrage fehlgeschlagen. Der Dienst ist möglicherweise nicht verfügbar. Bitte versuchen Sie es in ein paar Minuten erneut."
],
	"\u0000Inserting AI content will take some time, please wait...\u0001": [
	"Das Einfügen von KI-Inhalten wird einige Zeit dauern, bitte warten..."
],
	"\u0000At least one filtered comment will be removed, too. Do you want to continue?\u0001": [
	"Mindestens ein gefilterter Kommentar wird ebenso entfernt. Wollen Sie fortfahren?"
],
	"\u0000All comments in the document will be removed. Do you want to continue?\u0001": [
	"Alle Kommentare im Dokument werden entfernt. Möchten Sie fortfahren?"
],
	"\u0000The search continues from the end of this document.\u0001": [
	"Die Suche wird am Ende dieses Dokuments fortgesetzt."
],
	"\u0000Filled circle\u0001": [
	"Gefüllter Kreis"
],
	"\u0000Small filled circle\u0001": [
	"Kleiner gefüllter Kreis"
],
	"\u0000Circle\u0001": [
	"Kreis"
],
	"\u0000Small circle\u0001": [
	"Kleiner Kreis"
],
	"\u0000Filled square\u0001": [
	"Gefülltes Quadrat"
],
	"\u0000Small filled square\u0001": [
	"Kleines gefülltes Quadrat"
],
	"\u0000Square\u0001": [
	"Quadrat"
],
	"\u0000Small square\u0001": [
	"Kleines Quadrat"
],
	"\u0000Filled diamond\u0001": [
	"Gefüllte Raute"
],
	"\u0000Diamond\u0001": [
	"Raute"
],
	"\u0000Filled triangle\u0001": [
	"Gefülltes Dreieck"
],
	"\u0000Chevron\u0001": [
	"Chevron"
],
	"\u0000Dash\u0001": [
	"Bindestrich"
],
	"\u0000No symbol\u0001": [
	"Kein Symbol"
],
	"\u0000Decimal numbers\u0001": [
	"Dezimalzahlen"
],
	"\u0000Small Latin letters\u0001": [
	"Lateinische Kleinbuchstaben"
],
	"\u0000Capital Latin letters\u0001": [
	"Lateinische Großbuchstaben"
],
	"\u0000Small Roman numbers\u0001": [
	"Kleine römische Ziffern"
],
	"\u0000Capital Roman numbers\u0001": [
	"Große römische Ziffern"
],
	"\u0000Style %1$d\u0001": [
	"Stil %1$d"
],
	"\u0000Create paragraph style\u0001": [
	"Absatzstil erstellen"
],
	"\u0000Rename paragraph style \"%1$s\"\u0001": [
	"Absatzstil \"%1$s\" umbenennen"
],
	"\u0000Please wait while updating document.\u0001": [
	"Bitte warten Sie, während das Dokument aktualisiert wird."
],
	"\u0000Paragraph fill color\u0001": [
	"Absatzhintergrundfarbe"
],
	"\u0000Paragraph borders\u0001": [
	"Absatzumrandung"
],
	"\u0000Header & footer\u0001": [
	"Kopf- und Fußzeile"
],
	"\u0000Insert header & footer in document\u0001": [
	"Kopf- und Fußzeile in Dokument einfügen"
],
	"\u0000Same across entire document\u0001": [
	"Identisch im gesamten Dokument"
],
	"\u0000Different first page\u0001": [
	"Unterschiedliche erste Seite"
],
	"\u0000Different even & odd pages\u0001": [
	"Unterschiedliche gerade & ungerade Seiten"
],
	"\u0000Different first, even & odd pages\u0001": [
	"Untersch. erste Seite, gerade & ungerade Seiten"
],
	"\u0000Remove all headers and footers\u0001": [
	"Alle Kopf- und Fußzeilen entfernen"
],
	"\u0000Page number\u0001": [
	"Seitennummer"
],
	"\u0000Page count\u0001": [
	"Seitenanzahl"
],
	"\u0000Author name\u0001": [
	"Name des Autors"
],
	"\u0000Create, transform or translate content with AI\u0001": [
	"Inhalte mit KI erstellen, transformieren oder übersetzen"
],
	"\u0000Report\u0001": [
	"Bericht"
],
	"\u0000Story\u0001": [
	"Geschichte"
],
	"\u0000Article\u0001": [
	"Artikel"
],
	"\u0000Essay\u0001": [
	"Aufsatz"
],
	"\u0000Research paper\u0001": [
	"Forschungsarbeit"
],
	"\u0000Memo\u0001": [
	"Memo"
],
	"\u0000Letter\u0001": [
	"Letter"
],
	"\u0000Resume\u0001": [
	"Fortsetzen"
],
	"\u0000Instruction\u0001": [
	"Anleitung"
],
	"\u0000Invoice\u0001": [
	"Rechnung"
],
	"\u0000Contract\u0001": [
	"Vertrag"
],
	"\u0000Whitepaper\u0001": [
	"Whitepaper"
],
	"\u0000Newsletter\u0001": [
	"Newsletter"
],
	"\u0000Travel report\u0001": [
	"Reisebericht"
],
	"\u0000Replace selected text in document\u0001": [
	"Markierten Text im Dokument ersetzen"
],
	"\u0000Add before selected text in document\u0001": [
	"Vor markiertem Text im Dokument einfügen"
],
	"\u0000Add behind selected text in document\u0001": [
	"Nach markiertem Text im Dokument einfügen"
],
	"\u0000Generate or transform content\u0001": [
	"Inhalte generieren oder transformieren"
],
	"\u0000Generate\u0001": [
	"Generieren"
],
	"\u0000Transform\u0001": [
	"Transformieren"
],
	"\u0000Translate to\u0001": [
	"Übersetzen nach"
],
	"\u0000Action\u0001": [
	"Aktion"
],
	"\u0000Translate from\u0001": [
	"Übersetzen von"
],
	"\u0000Document type\u0001": [
	"Dokumenttyp"
],
	"\u0000Length\u0001": [
	"Länge"
],
	"\u0000Short\u0001": [
	"Kurz"
],
	"\u0000Medium\u0001": [
	"Mittel"
],
	"\u0000Long\u0001": [
	"Lang"
],
	"\u0000Tone\u0001": [
	"Ton"
],
	"\u0000Formal\u0001": [
	"Formell"
],
	"\u0000Neutral\u0001": [
	"Neutral"
],
	"\u0000Informal\u0001": [
	"Informell"
],
	"\u0000Mood\u0001": [
	"Stimmung"
],
	"\u0000Exciting\u0001": [
	"Spannend"
],
	"\u0000Friendly\u0001": [
	"Freundlich"
],
	"\u0000Positive\u0001": [
	"Positiv"
],
	"\u0000Rejecting\u0001": [
	"Ablehnend"
],
	"\u0000Disappointed\u0001": [
	"Enttäuscht"
],
	"\u0000Please add keywords or text to fine-tune your content!\u0001": [
	"Für eine Feinabstimmung Ihrer Inhalte fügen Sie bitte Schlüsselwörter oder Text hinzu!"
],
	"\u0000Your input is restricted to the maximum length of %1$d characters!\u0001": [
	"Ihre Eingabe ist auf die maximale Länge von %1$d Zeichen beschränkt!"
],
	"\u0000Generated result\u0001": [
	"Generiertes Ergebnis"
],
	"\u0000Your feedback on AI integration ...\u0001": [
	"Ihr Feedback zur KI-Integration ..."
],
	"\u0000Your input\u0001": [
	"Ihre Eingabe"
],
	"\u0000Keywords (optional)\u0001": [
	"Schlüsselwörter (optional)"
],
	"\u0000%1$d characters remaining\u0001": [
	"%1$d verbleibende Zeichen"
],
	"\u0000Regenerate\u0001": [
	"Neu generieren"
],
	"\u0000Use content\u0001": [
	"Inhalt verwenden"
],
	"\u0000Paragraph\u0001": [
	"Absatz"
],
	"\u0000Indentation\u0001": [
	"Einzug"
],
	"\u0000Left\u0001": [
	"Links"
],
	"\u0000Set left indent\u0001": [
	"Linken Einzug festlegen"
],
	"\u0000Right\u0001": [
	"Rechts"
],
	"\u0000Set right indent\u0001": [
	"Rechten Einzug festlegen"
],
	"\u0000First line\u0001": [
	"Erste Zeile"
],
	"\u0000Set paragraph's first line indent\u0001": [
	"Einzug der ersten Zeile des Absatzes festlegen"
],
	"\u0000Page %1$d\u0001": [
	"Seite %1$d"
],
	"\u0000Page %1$d of %2$d\u0001": [
	"Seite %1$d von %2$d"
],
	"\u0000Left indent\u0001": [
	"Linker Einzug"
],
	"\u0000Right indent\u0001": [
	"Rechter Einzug"
],
	"\u0000First line indent\u0001": [
	"Einzug der ersten Zeile"
],
	"\u0000There are no comments in this document.\u0001": [
	"Dieses Dokument enthält keine Kommentare."
],
	"change-tracking\u0000Inserted\u0001": [
	"Eingefügt"
],
	"change-tracking\u0000Deleted\u0001": [
	"Gelöscht"
],
	"change-tracking\u0000Formatted\u0001": [
	"Formatiert"
],
	"change-tracking\u0000Text\u0001": [
	"Text"
],
	"change-tracking\u0000Paragraph\u0001": [
	"Absatz"
],
	"change-tracking\u0000Table\u0001": [
	"Tabelle"
],
	"change-tracking\u0000Table row\u0001": [
	"Tabellenzeile"
],
	"change-tracking\u0000Table cell\u0001": [
	"Tabellenzelle"
],
	"change-tracking\u0000Text frame\u0001": [
	"Textrahmen"
],
	"change-tracking\u0000Shape\u0001": [
	"Form"
],
	"change-tracking\u0000Drawing\u0001": [
	"Zeichnung"
],
	"\u0000Unknown\u0001": [
	"Unbekannt"
],
	"\u0000Change tracking\u0001": [
	"Änderungsnachverfolgung"
],
	"\u0000Accept this change in the document\u0001": [
	"Diese Änderung im Dokument übernehmen"
],
	"\u0000Reject\u0001": [
	"Ablehnen"
],
	"\u0000Reject this change in the document\u0001": [
	"Diese Änderung im Dokument ablehnen"
],
	"\u0000Show\u0001": [
	"Zeigen"
],
	"\u0000Show this change in the document\u0001": [
	"Diese Änderung im Dokument anzeigen"
],
	"\u0000Custom\u0001": [
	"Benutzerdefiniert"
],
	"\u0000Update this date field automatically on document load, download and mail\u0001": [
	"Dieses Datumsfeld automatisch aktualisieren beim Laden und Herunterladen des Dokuments sowie beim Versenden des Dokuments per E-Mail"
],
	"\u0000Set to today\u0001": [
	"Auf heutigen Tag eingestellt"
],
	"\u0000Set to today's date\u0001": [
	"Auf heutiges Datum eingestellt"
],
	"\u0000Pick date\u0001": [
	"Datum wählen"
],
	"\u0000Edit field\u0001": [
	"Feld bearbeiten"
],
	"\u0000Field formatting\u0001": [
	"Feldformatierung"
],
	"\u0000Select format\u0001": [
	"Format wählen"
],
	"\u0000Change date\u0001": [
	"Datum ändern"
],
	"\u0000Paragraph formatting\u0001": [
	"Absatzformatierung"
],
	"\u0000Yesterday\u0001": [
	"Gestern"
],
	"\u0000Show ruler\u0001": [
	"Lineal anzeigen"
],
	"\u0000Toggle ruler next to document\u0001": [
	"Lineal neben Dokument an/aus"
],
	"\u0000Line break\u0001": [
	"Zeilenumbruch"
],
	"\u0000Insert line break\u0001": [
	"Zeilenumbruch einfügen"
],
	"\u0000Page break\u0001": [
	"Seitenumbruch"
],
	"\u0000Insert page break\u0001": [
	"Seitenumbruch einfügen"
],
	"\u0000Split table\u0001": [
	"Tabelle teilen"
],
	"\u0000Turn automatic height resizing of text frames on or off\u0001": [
	"Automatische Höhenanpassung von Textrahmen ein- oder ausschalten"
],
	"\u0000On\u0001": [
	"An"
],
	"\u0000Track changes\u0001": [
	"Änderungen nachverfolgen"
],
	"\u0000Turn change tracking on or off\u0001": [
	"Änderungsnachverfolgung an- oder abschalten "
],
	"\u0000Accept the current change and select the next change\u0001": [
	"Aktuelle Änderung übernehmen und zur nächsten Änderung gehen"
],
	"\u0000Reject the current change and select the next change\u0001": [
	"Aktuelle Änderung ablehnen und zur nächsten Änderung gehen"
],
	"\u0000Accept the current change\u0001": [
	"Aktuelle Änderung übernehmen"
],
	"\u0000Reject the current change\u0001": [
	"Aktuelle Änderung ablehnen"
],
	"\u0000Previous\u0001": [
	"Zurück"
],
	"\u0000Select the previous change in the document\u0001": [
	"Zur vorherigen Änderung im Dokument gehen"
],
	"\u0000Next\u0001": [
	"Weiter"
],
	"\u0000Select the next change in the document\u0001": [
	"Zur nächsten Änderung im Dokument gehen"
],
	"\u0000Select the previous comment in the document\u0001": [
	"Vorherigen Kommentar im Dokument wählen"
],
	"\u0000Select the next comment in the document\u0001": [
	"Nächsten Kommentar im Dokument wählen"
],
	"\u0000Delete all\u0001": [
	"Alle löschen"
],
	"\u0000Delete all comments\u0001": [
	"Alle Kommentare löschen"
],
	"\u0000There are no tracked changes in your document.\u0001": [
	"Ihr Dokument enthält keine nachverfolgbaren Änderungen."
],
	"\u0000No table of contents entries in the document.\u0001": [
	"Keine Inhaltsverzeichniseinträge im Dokument."
],
	"\u0000Contents\u0001": [
	"Inhalte"
],
	"\u0000Preparing Table of contents.\u0001": [
	"Inhaltsverzeichnis vorbereiten."
],
	"\u0000Updating Table of contents will take some time, please wait...\u0001": [
	"Das Aktualisieren des Inhaltsverzeichnisses wird etwas dauern. Bitte warten ..."
],
	"\u0000Contents heading\u0001": [
	"Inhalte Überschrift"
],
	"\u0000Table of contents\u0001": [
	"Inhaltsverzeichnis"
],
	"\u0000Inserting Table of contents will take some time, please wait...\u0001": [
	"Das Einfügen des Inhaltsverzeichnisses wird etwas dauern. Bitte warten ..."
],
	"\u0000lowercase\u0001": [
	"kleinbuchstaben"
],
	"\u0000UPPERCASE\u0001": [
	"GROSSBUCHSTABEN"
],
	"\u0000First capital\u0001": [
	"Satzanfang groß"
],
	"\u0000Title Case\u0001": [
	"Große Anfangsbuchstaben"
],
	"\u0000hexadecimal\u0001": [
	"Hexadezimal"
],
	"\u0000Table of Contents. Right click...\u0001": [
	"Inhaltsverzeichnis. Rechter Mausklick ..."
],
	"\u0000Updating all fields in document will take some time.\u0001": [
	"Das Aktualisieren aller Felder im Dokument wird etwas dauern."
],
	"\u0000Header\u0001": [
	"Kopfzeile"
],
	"\u0000Odd header\u0001": [
	"Ungerade Kopfzeile"
],
	"\u0000Odd footer\u0001": [
	"Ungerade Fußzeile"
],
	"\u0000First header\u0001": [
	"Erste Kopfzeile"
],
	"\u0000First footer\u0001": [
	"Erste Fußzeile"
],
	"\u0000Even header\u0001": [
	"Gerade Kopfzeile"
],
	"\u0000Even footer\u0001": [
	"Gerade Fußzeile"
],
	"\u0000Go to footer\u0001": [
	"Zu Fußzeile wechseln"
],
	"\u0000Go to header\u0001": [
	"Zu Kopfzeile wechseln"
],
	"\u0000Replacing text.\u0001": [
	"Der Text wird ersetzt."
],
	"\u0000No search result found.\u0001": [
	"Es wurde kein Suchergebnis gefunden."
],
	"\u0000This document contains text in languages which could not be proofed: %1$s\u0001": [
	"Dieses Dokument enthält Text in Sprachen, die nicht geprüft werden konnten: %1$s"
],
	"\u0000Set language notification.\u0001": [
	"Benachrichtigungen für Sprachen festlegen."
],
	"\u0000Sorry, formatting content will take some time.\u0001": [
	"Das Formatieren des Inhalts wird leider etwas dauern."
],
	"\u0000The selected text is very long. It will take some time to be copied. Do you really want to continue?\u0001": [
	"Der markierte Text ist sehr lang. Das Kopieren wird etwas dauern. Wollen Sie fortfahren?"
],
	"\u0000Pasting shapes into comments is not supported.\u0001": [
	"Das Einfügen von Formen in Anmerkungen wird nicht unterstützt."
],
	"\u0000Pasting shapes into text frames is not supported.\u0001": [
	"Das Einfügen von Formen in Textrahmen wird nicht unterstützt."
],
	"\u0000Pasting content into this object is not supported.\u0001": [
	"Das Einfügen von Inhalt in dieses Objekt wird nicht unterstützt."
],
	"\u0000Pasting fields into comments is not supported.\u0001": [
	"Das Einfügen von Feldern in Kommentare wird nicht unterstützt."
],
	"\u0000Pasting lists into comments is not supported.\u0001": [
	"Das Einfügen von Listen in Kommentare wird nicht unterstützt."
],
	"\u0000Pasting groups with tables is not supported.\u0001": [
	"Das Einfügen von Gruppen mit Tabellen wird nicht unterstützt."
],
	"\u0000Sorry, pasting from clipboard will take some time.\u0001": [
	"Das Kopieren aus der Zwischenablage wird leider etwas dauern."
],
	"\u0000Sorry, pasting slides from clipboard will take some time.\u0001": [
	"Das Kopieren von Folien aus der Zwischenablage wird leider etwas dauern."
],
	"\u0000Sorry, deleting content will take some time.\u0001": [
	"Das Löschen des Inhalts wird leider etwas dauern."
],
	"\u0000Sorry, applying changes will take some time.\u0001": [
	"Das Übernehmen der Änderungen wird leider etwas dauern."
],
	"\u0000Black diamond\u0001": [
	"Schwarze Raute"
],
	"\u0000Arrow head\u0001": [
	"Pfeilspitze"
],
	"\u0000Check mark\u0001": [
	"Häkchen"
],
	"\u0000This table is too large to be displayed here.\u0001": [
	"Diese Tabelle ist zu groß, um hier dargestellt zu werden."
],
	"\u0000The table contains %1$d row.\u0001This table contains %1$d rows.": [
	"Die Tabelle enthält %1$d Zeile.",
	"Die Tabelle enthält %1$d Zeilen."
],
	"\u0000Tables are limited to %1$d row.\u0001Tables are limited to %1$d rows.": [
	"Tabellen sind auf %1$d Zeile beschränkt.",
	"Tabellen sind auf %1$d Zeilen beschränkt."
],
	"\u0000The table contains %1$d column.\u0001This table contains %1$d columns.": [
	"Die Tabelle enthält %1$d Spalte.",
	"Die Tabelle enthält %1$d Spalten."
],
	"\u0000Tables are limited to %1$d column.\u0001Tables are limited to %1$d columns.": [
	"Tabellen sind auf %1$d Spalte beschränkt.",
	"Tabellen sind auf %1$d Spalten beschränkt."
],
	"\u0000The table contains %1$d cell.\u0001This table contains %1$d cells.": [
	"Die Tabelle enthält %1$d Zelle.",
	"Die Tabelle enthält %1$d Zellen."
],
	"\u0000Tables are limited to %1$d cell.\u0001Tables are limited to %1$d cells.": [
	"Tabellen sind auf %1$d Zelle beschränkt.",
	"Tabellen sind auf %1$d Zellen beschränkt."
],
	"drawing-pos\u0000Position\u0001": [
	"Position"
],
	"drawing-pos\u0000Drawing position\u0001": [
	"Zeichnungsausrichtung"
],
	"drawing-pos\u0000Left aligned, no text wrapping\u0001": [
	"Links ausgerichtet, kein Textumlauf"
],
	"drawing-pos\u0000Left aligned, text wraps at right side\u0001": [
	"Links ausgerichtet, Textumlauf rechts"
],
	"drawing-pos\u0000Right aligned, no text wrapping\u0001": [
	"Rechts ausgerichtet, kein Textumlauf"
],
	"drawing-pos\u0000Right aligned, text wraps at left side\u0001": [
	"Rechts ausgerichtet, Textumlauf links"
],
	"drawing-pos\u0000Centered, no text wrapping\u0001": [
	"Zentriert, kein Textumlauf"
],
	"drawing-pos\u0000Centered, text wraps at left side\u0001": [
	"Zentriert, Textumlauf links"
],
	"drawing-pos\u0000Centered, text wraps at right side\u0001": [
	"Zentriert, Textumlauf rechts"
],
	"\u0000Bullet list\u0001": [
	"Aufzählungsliste"
],
	"\u0000Numbered list\u0001": [
	"Nummerierte Liste"
],
	"\u0000With dots and page numbers\u0001": [
	"Mit Punkten und Seitenzahlen"
],
	"\u0000With page numbers\u0001": [
	"Mit Seitenzahlen"
],
	"\u0000Headings only\u0001": [
	"Nur Überschriften"
],
	"\u0000Insert table of contents\u0001": [
	"Inhaltsverzeichnis einfügen"
],
	"\u0000Heading %1$d\u0001": [
	"Überschrift %1$d"
],
	"\u0000Paragraph alignment\u0001": [
	"Absatzausrichtung"
],
	"\u0000100%\u0001": [
	"100%"
],
	"\u0000115%\u0001": [
	"115%"
],
	"\u0000150%\u0001": [
	"150%"
],
	"\u0000200%\u0001": [
	"200%"
],
	"paragraph-spacing\u0000None\u0001": [
	"Kein"
],
	"paragraph-spacing\u0000Normal\u0001": [
	"Normal"
],
	"paragraph-spacing\u0000Wide\u0001": [
	"Breit"
],
	"\u0000Subscript\u0001": [
	"Tiefstellung"
],
	"\u0000Superscript\u0001": [
	"Hochstellung"
],
	"\u0000Comment authors\u0001": [
	"Kommentarverfasser"
],
	"\u0000Show comment authors\u0001": [
	"Kommentarverfasser anzeigen"
],
	"\u0000Markup\u0001": [
	"Markup"
],
	"\u0000Highlight comments mode\u0001": [
	"Kommentaranzeige"
],
	"\u0000Highlight all comments\u0001": [
	"Alle Kommentare hervorheben"
],
	"\u0000Highlight selected comments\u0001": [
	"Gewählte Kommentare hervorheben"
],
	"\u0000Show bubble comments\u0001": [
	"Kommentare in Sprechblasen anzeigen"
],
	"\u0000Show no comments\u0001": [
	"Keine Kommentare anzeigen"
],
	"drawing-pos\u0000Alignment\u0001": [
	"Ausrichtung"
],
	"drawing-pos\u0000Drawing alignment\u0001": [
	"Grafikausrichtung"
],
	"drawing-pos\u0000Move with text\u0001": [
	"Mit Text verschieben"
],
	"drawing-pos\u0000Move with paragraph\u0001": [
	"Mit Absatz verschieben"
],
	"drawing-pos\u0000Move with page margin\u0001": [
	"Mit Seitenrändern verschieben"
],
	"drawing-pos\u0000Move with page\u0001": [
	"Mit Seite verschieben"
],
	"\u0000Change style \"%1$s\"\u0001": [
	"Stil \"%1$s\" ändern"
],
	"\u0000Set image width\u0001": [
	"Bildbreite festlegen"
],
	"\u0000Set image height\u0001": [
	"Bildhöhe festlegen"
],
	"\u0000Set horizontal offset\u0001": [
	"Horizontalen Versatz festlegen"
],
	"\u0000Set vertical offset\u0001": [
	"Vertikalen Versatz festlegen"
],
	"\u0000Set crop position width\u0001": [
	"Breite des Schnittrahmens festlegen"
],
	"\u0000Set crop position height\u0001": [
	"Höhe des Schnittrahmens festlegen"
],
	"\u0000Set left position\u0001": [
	"Linke Position festlegen"
],
	"\u0000Set top position\u0001": [
	"Obere Position festlegen"
],
	"\u0000Crop position\u0001": [
	"Zuschnittposition"
],
	"\u0000Image position\u0001": [
	"Bildposition"
],
	"\u0000Width\u0001": [
	"Breite"
],
	"\u0000Height\u0001": [
	"Höhe"
],
	"\u0000Offset X\u0001": [
	"X-Versatz"
],
	"\u0000Offset Y\u0001": [
	"Y-Versatz"
],
	"\u0000Crop frame position\u0001": [
	"Schnittrahmen-Position"
],
	"\u0000Top\u0001": [
	"Oben"
],
	"\u0000Bottom\u0001": [
	"Unten"
],
	"\u0000Paper format\u0001": [
	"Papierformat"
],
	"\u0000Paper orientation\u0001": [
	"Seitenausrichtung"
],
	"\u0000Page margins\u0001": [
	"Seitenränder"
],
	"\u0000Paper size\u0001": [
	"Papiergröße"
],
	"\u0000Slide format\u0001": [
	"Folienformat"
],
	"\u0000Orientation\u0001": [
	"Anordnung"
],
	"\u0000Slide size\u0001": [
	"Foliengröße"
],
	"\u0000Tabloid\u0001": [
	"Tabloid"
],
	"\u0000Legal\u0001": [
	"Legal"
],
	"\u0000Statement\u0001": [
	"Statement"
],
	"\u0000Executive\u0001": [
	"Executive"
],
	"\u0000Folio\u0001": [
	"Folio"
],
	"\u0000A3\u0001": [
	"A3"
],
	"\u0000A4\u0001": [
	"A4"
],
	"\u0000A5\u0001": [
	"A5"
],
	"\u0000B4\u0001": [
	"B4"
],
	"\u0000B5\u0001": [
	"B5"
],
	"\u0000Standard (4:3)\u0001": [
	"Standard (4:3)"
],
	"\u0000Widescreen (16:9)\u0001": [
	"Breitbild (16:9)"
],
	"\u0000Widescreen (16:10)\u0001": [
	"Breitbild (16:10)"
],
	"\u0000Widescreen HD (16:9)\u0001": [
	"Breitbild HD (16:9)"
],
	"\u0000Portrait\u0001": [
	"Hochformat"
],
	"\u0000Landscape\u0001": [
	"Querformat"
],
	"\u0000Narrow\u0001": [
	"Schmal"
],
	"\u0000Normal\u0001": [
	"Normal"
],
	"\u0000Wide\u0001": [
	"Breit"
],
	"\u0000Invalid name for a paragraph style.\u0001": [
	"Ungültiger Name für einen Absatzstil."
],
	"\u0000Paragraph style \"%1$s\" exists already.\u0001": [
	"Absatzstil \"%1$s\" ist bereits vorhanden."
],
	"\u0000More font styles\u0001": [
	"Weitere Schriftvorlagen"
],
	"\u0000Text alignment\u0001": [
	"Textausrichtung"
],
	"\u0000Align text vertically inside textbox\u0001": [
	"Text innerhalb des Textfeldes vertikal ausrichten"
],
	"\u0000Align text horizontally and vertically inside textbox\u0001": [
	"Text innerhalb des Textfeldes horizontal und vertikal ausrichten"
],
	"\u0000Text position\u0001": [
	"Textausrichtung"
],
	"\u0000Line spacing\u0001": [
	"Zeilenabstand"
],
	"\u0000Paragraph spacing\u0001": [
	"Absatzabstand"
],
	"\u0000Paragraph & Line spacing\u0001": [
	"Absatz- & Zeilenabstand"
],
	"\u0000Middle\u0001": [
	"Mitte"
],
	"\u0000Follow anchor link\u0001": [
	"Ankerlink folgen"
],
	"\u0000Click to go to this paragraph in document\u0001": [
	"Klicken Sie, um zu diesem Absatz im Dokument zu gehen"
],
	"\u0000Show alignment guides\u0001": [
	"Führungslinien einblenden"
],
	"\u0000Show or hide alignment guides on shape move or resize\u0001": [
	"Führungslinien für das Verschieben oder die Größenanpassung von Formen ein- oder ausblenden"
],
	"\u0000Accept and next\u0001": [
	"Übernehmen und Weiter"
],
	"\u0000Accept this change\u0001": [
	"Diese Änderung übernehmen"
],
	"\u0000Accept all changes\u0001": [
	"Alle Änderungen übernehmen"
],
	"\u0000Accept all changes in the document\u0001": [
	"Alle Änderungen im Dokument übernehmen"
],
	"\u0000Reject and next\u0001": [
	"Ablehnen und Weiter"
],
	"\u0000Reject this change\u0001": [
	"Diese Änderung ablehnen"
],
	"\u0000Reject all changes\u0001": [
	"Alle Änderungen ablehnen"
],
	"\u0000Reject all changes in the document\u0001": [
	"Alle Änderungen am Dokument ablehnen"
],
	"\u0000Paragraph style\u0001": [
	"Absatzstil"
],
	"\u0000Apply style\u0001": [
	"Stil anwenden"
],
	"\u0000Update style\u0001": [
	"Stil aktualisieren"
],
	"\u0000Update current style from selection\u0001": [
	"Aktuellen Stil aus Auswahl aktualisieren"
],
	"\u0000Rename style\u0001": [
	"Stil umbenennen"
],
	"\u0000Delete style\u0001": [
	"Stil löschen"
],
	"\u0000Create new style\u0001": [
	"Neuen Stil anlegen"
],
	"\u0000Create new style from selection\u0001": [
	"Neuen Stil aus Auswahl erstellen"
],
	"\u0000Format painter\u0001": [
	"Format übertragen"
],
	"\u0000Edit field format\u0001": [
	"Feldformat bearbeiten"
],
	"\u0000Edit format of selected field\u0001": [
	"Format des markierten Felds bearbeiten"
],
	"\u0000Update field\u0001": [
	"Feld aktualisieren"
],
	"\u0000Update selected field\u0001": [
	"Markiertes Feld aktualisieren"
],
	"\u0000Update all fields\u0001": [
	"Alle Felder aktualisieren"
],
	"\u0000Update all fields in document\u0001": [
	"Alle Felder im Dokument aktualisieren"
],
	"\u0000Insert current slide number\u0001": [
	"Aktuelle Foliennummer einfügen"
],
	"\u0000Insert current date and time\u0001": [
	"Aktuelles Datum und Uhrzeit einfügen"
],
	"\u0000Insert footer with fields like date and slide number\u0001": [
	"Fußzeile mit Feldern wie Datum und Foliennummer einfügen"
],
	"\u0000Ignore all\u0001": [
	"Alle ignorieren"
],
	"\u0000Add to dictionary\u0001": [
	"Zum Wörterbuch hinzufügen"
],
	"\u0000Start list with first value\u0001": [
	"Liste mit erstem Wert starten"
],
	"\u0000Continue list numbering\u0001": [
	"Listennummerierung fortführen"
],
	"\u0000Table of contents layouts\u0001": [
	"Layouts für Inhaltsverzeichnis"
],
	"\u0000Change current layout\u0001": [
	"Aktuelles Layout ändern"
],
	"\u0000Delete table\u0001": [
	"Tabelle löschen"
],
	"\u0000Text highlight color\u0001": [
	"Textmarkierungsfarbe"
],
	"\u0000Colors\u0001": [
	"Farben"
],
	"\u0000Indent less\u0001": [
	"Einzug verkleinern"
],
	"\u0000Indent more\u0001": [
	"Einzug vergrößern"
],
	"check-list\u0000Select all\u0001": [
	"Alle wählen"
],
	"\u0000Create folder\u0001": [
	"Ordner anlegen"
],
	"\u0000File name\u0001": [
	"Dateiname"
],
	"\u0000OK\u0001": [
	"OK"
],
	"\u0000Close\u0001": [
	"Schließen"
],
	"\u0000Yes\u0001": [
	"Ja"
],
	"\u0000No\u0001": [
	"Nein"
],
	"language\u0000%1$s (%2$s)\u0001": [
	"%1$s (%2$s)"
],
	"\u0000Recently used\u0001": [
	"Kürzlich verwendet"
],
	"\u0000You do not have permissions to access the file.\u0001": [
	"Sie haben keine Berechtigung zum Zugriff auf die Datei."
],
	"\u0000You do not have permissions to modify the file.\u0001": [
	"Sie haben keine Berechtigung zum Ändern der Datei."
],
	"\u0000You do not have permissions to create the file.\u0001": [
	"Sie haben keine Berechtigung zum Anlegen der Datei."
],
	"\u0000The file does not exist anymore. Please refresh your application.\u0001": [
	"Die Datei existiert nicht mehr. Bitte aktualisieren Sie Ihre Anwendung."
],
	"\u0000The folder does not exist anymore. Please refresh your application.\u0001": [
	"Der Ordner existiert nicht mehr. Bitte aktualisieren Sie Ihre Anwendung."
],
	"\u0000Your quota has been exceeded. Please remove files then try again.\u0001": [
	"Ihr Kontingent wurde überschritten. Bitte entfernen Sie Dateien und versuchen Sie es erneut."
],
	"\u0000Editing encrypted files is currently not supported.\u0001": [
	"Die Bearbeitung von verschlüsselten Dateien wird derzeit nicht unterstützt."
],
	"\u0000Failed to start application. Maybe you have connection problems. Please try again.\u0001": [
	"Die Applikation konnte nicht gestartet werden. Vielleicht haben Sie Verbindungsprobleme. Bitte versuchen Sie es erneut."
]
};
